export default {
    VIETNAMESE: "Tiếng việt",
    ENGLISH: "English",
    JAPANESE: "日本語",
    KOREAN: "한국어",
    CHINESE: "中文",
    LAO: "ພາສາລາວ",
    KHMER: "ភាសាខ្មែរ",
    SYNC: "同期",
    PLEASE_SELECT_DATE_LESS_6_MONTH: "6ヶ月以内の日付範囲を選択してください",
    CHAIN_DASHBOARD_INFO: "チェーン",
    CHAIN_DASHBOARD: "チェーンダッシュボード",
    BOOKING_DASHBOARD: "予約ダッシュボード",
    USE_HOTEL: "ホテルを利用する",
    CANCEL_SUCCESS: "更新が成功しました",
    BOOKING_PAID: "支払済み",
    BOOKING_CANCELED: "予約をキャンセルできません。ステータスを確認してください",
    LOCATION_IS_NOT_EXIST: "場所が存在しません",
    ROOM_AVAILS_INCORRECT: "空室数が申告された総部屋数を超えることはできません",
    PROMOTION_NULL: "プロモーションが存在しません",
    CANCLE_FAILE: "キャンセル失敗",
    DELETE_FAILE: "削除失敗",
    GROUP_USED: "ユーザーグループが使用中です",
    TRANSDATE_INCORRECT: "支払日は予約日とチェックアウト日の間でなければなりません",
    AMOUNT_INCORRECT: "支払金額が正しくありません",
    HAS_NO_DATA: "データがありません",
    LOCATION_NOT_EXIST: "場所が存在しません",
    UPDATE_SUCCESS: "更新が成功しました",
    UPDATE_CUCCESS: "更新が成功しました",
    DELETE_SUCCESS: "削除が成功しました",
    CREATE_SUCCESS: "作成が成功しました",
    REGISTER_SUCCESS: "登録が成功しました",
    UPLOAD_SUCCESS: "アップロードが成功しました",
    PROMOTIONS_ARE_BEING_USED: "プロモーションが使用されています",
    PROMOTIONS_DO_NOT_BELONG_TO_HOTELS: "プロモーションがホテルに属していません",
    COUNPON_EXIST: "クーポンが存在します",
    USER_IS_EXIST: "ユーザー名が既に存在します",
    EMAIL_USER_IS_EXIST: "メールアドレスが既に存在します",
    EMAIL_HOTEL_IS_EXIST: "ホテルのメールアドレスが既に存在します",
    ACCOUNT_IS_TAKEN: "ユーザー名が使用されています",
    USER_NAME_OR_EMAIL_IS_EXISTED: "ユーザー名またはメールアドレスが既に存在します",
    CANNOT_FIND_SOURCE: "ソースが見つかりません",
    IMAGE_CAPACITY_NOT_BIGGER_THAN: "最大アップロード画像サイズ：",
    FILE_CAPACITY_NOT_BIGGER_THAN: "最大アップロードファイルサイズ：",
    IMAGE_SIZE_NOT_BIGGER_THAN: "写真の最小サイズ",
    INVALID_IMAGE_FORMAT: "無効な画像フォーマット",
    INVALID_FILE_FORMAT: "無効なファイルフォーマット",
    DELETE_FAIL: "削除失敗",
    IMAGE_MAIN_EMPTY: "メイン画像が空です",
    ROOM_EMPTY: "部屋が空です",
    ROOM_IS_SELECTING: "部屋を選択中",
    NOT_SELECTED_PROMOTION: "プロモーションが選択されていません",
    MISSING_FIELD: "必要な情報をすべて入力してください",
    CONFIRM_DELETE_PHOTOS: "写真の削除を確認",
    MAIN_IMAGES_MUST_EXIST: "メイン写真が必要です",
    CONFIRM_DELETE_POLICY: "ポリシーの削除を確認",
    CONFIRM_DELETE_SALE_PACKAGE: "この販売パッケージの削除を確認",
    CONFIRM_DELETE_PROMOTION_PACKAGE: "このプロモーションパッケージの削除を確認",
    CONFIRM_DELETE_ROOM: "部屋の削除を確認",
    UPLOAD_EXPIRED: "アップロード期限切れ",
    PAYMENT_METHOD_HAS_NOT_SELECTED: "支払い方法が選択されていません",
    SETTING_GATEWAY_EMPTY: "ゲートウェイ設定が存在しません",
    DEPOSIT_COMPARE_PAYMENT: "支払い期日はデポジット支払い期限を超えることはできません",
    TIP_MAIN_IMAGE: "ホテルアバターは最初の写真です。写真をドラッグ＆ドロップして表示順を変更できます",
    TIP_MAIN_ROOM_IMAGE: "部屋アバターは最初の写真です。写真をドラッグ＆ドロップして表示順を変更できます",
    CUSTOMER_PACKAGE_NOT_BIGGER_THAN_ROOM: "パッケージの適用可能な合計人数は部屋の最大人数を超えることはできません",
    FIELD_NUMBER_FORMAT: "数値のみが許可され、スペースは含めないでください",
    FIELD_POSITIVE_FORMAT: "正の整数のみが許可され、スペースは含めないでください",
    FIELD_DISTANCE_FORMAT: "数値とピリオド（.）のみが許可され、スペースは含めないでください",
    CHAIN_NAME_EMPTY: "チェーン名が空です",
    USER_IS_NOT_EXIT: "ユーザーが存在しません",
    USER_IS_NOT_EXIST: "ユーザーが存在しません",
    HOTEL_WAS_IN_CHAIN: "ホテルがチェーン内にあります",
    DESCRIPTION_INFO: "説明",
    REQUIRED: "*",
    SELECT_ALL: "すべて選択",
    IMAGES: "写真",
    HOTEL_PHOTO: "ホテル写真",
    LIBRARY: "ギャラリー",
    ADD_NEW: "作成",
    AND: "と",
    BACK: "戻る",
    SAVE: "保存",
    EDIT: "編集",
    DELETE: "削除",
    COPY: "コピー",
    POLICY: "ポリシー",
    ALWAYS: "常に",
    IN_PERIOD: "期間",
    GENERAL_SETTING: "一般設定",
    PAYMENT_POLICY: "支払いポリシー",
    CANCELATION_POLICY: "キャンセルポリシー",
    PAY_GATE: "支払いゲート",
    AGENT_STOP_CONNECT: "エージェント接続停止",
    WARNING_METHOD: "警告方法",
    ALERT_RECEIVING_METHOD: "警告方法",
    SELECT_WARNING_METHOD: "警告方法を選択",
    WARNING_QTY_ROOM: "部屋数が設定した閾値に達したときの通知",
    SETTING_WARNING_ROOM: "部屋数が設定値に達したときに通知を送信",
    SEND_WARNING_ANY_ROOM: "任意の部屋タイプが設定値より少ない場合に通知を送信",
    SEND_WARNING_ROOM: "部屋数が設定値に達したときに通知を送信",
    QTY_ROOM_LESS_THAN: "部屋数が少ない",
    HOTEL_WARNING: "警告方法",
    SETTING_AT_LEAST_1_ROOM: "警告閾値を設定するために少なくとも1つの部屋タイプを選択してください",
    REGISTER_INFO: "登録情報",
    EXTENSION: "アメニティ",
    NEARBY_PLACE: "近隣施設",
    HOTEL_CHAIN: "ホテルチェーン",
    HOTEL_REGISTER_INFO: "ホテル登録情報",
    HOTEL_CODE: "ホテルコード",
    STAR_RATING: "星",
    HOTEL_LOGO: "ロゴ",
    CONTACT_PHONE: "電話番号",
    HOTEL_TYPE: "ホテルタイプ",
    COUNTRY: "国",
    CITY: "都道府県/市",
    DISTRICT: "区/コミューン/特別区",
    WARD: "町",
    HOTEL_NAME: "ホテル名",
    ADDRESS: "住所",
    MAP_LOCATION: "地図上の位置",
    LONGITUDE: "経度",
    LATITUDE: "緯度",
    DASHBOARD: "ダッシュボード",
    MANAGE: "管理",
    BOOK_ROOM: "部屋を予約",
    ROOM_SALE: "部屋販売",
    ROOM_AVAILABLE_AND_PRICE: "在庫と料金",
    SALE_AND_PROMOTION_PACKAGES: "販売およびプロモーションパッケージ",
    SETTING: "設定",
    ACCOUNT_INFO: "アカウント設定",
    ACCOUNT_SETTING: "個人アカウント",
    USER_MANAGE: "ユーザー管理",
    CONTRACT: "契約",
    HOTEL_INFOMATION: "ホテル設定",
    GENERAL_INFO: "一般設定",
    TYPE_ROOM: "部屋タイプ",
    HOTEL_CONFIG: "設定",
    GALLERY_MANAGER: "フォトギャラリー",
    TRAVEL_AGENT: "旅行代理店",
    ACTIVITY_DAIRY: "システムログ",
    ACTIVITY_DIARY_UPDATE_BULK: "一括更新ログ",
    ACTIVITY_DIARY_UPDATE_ROOM_AVAIL: "在庫更新ログ",
    SUPPORT: "サポート",
    INSTRUCTION_DOCUMENT: "説明書",
    INSTRUCTION_DOCUMENT_CONNECT_BE: "ウェブサイト統合",
    COPYED: "コピーしました",
    VIEW_DEMO: "予約エンジンページを見る",
    HOTLINE: "ホットライン",
    BOOKING_LIST: "予約一覧",
    REQUEST_BOOKING_LIST: "予約リクエスト",
    REVENUE_AND_EXPENDITURE_TRANSACTION: "取引",
    AGENT_LIST: "エージェント一覧",
    UNLINKED_LIST: "停止したエージェント",
    PREVIEW_ON_BE: "予約エンジンリンク",
    PREVIEW_ON_TA: "TAページを見る",
    SALE_CHANNEL: "チャンネル",
    CHANNEL_GROUP: "チャンネルグループ",
    SUNDAY: "日曜日",
    MONDAY: "月曜日",
    TUESDAY: "火曜日",
    WEDNESDAY: "水曜日",
    THURSDAY: "木曜日",
    FRIDAY: "金曜日",
    SATURDAY: "土曜日",
    _DATE_RANGE: {
        SUNDAY: "日",
        MONDAY: "月",
        TUESDAY: "火",
        WEDNESDAY: "水",
        THURSDAY: "木",
        FRIDAY: "金",
        SATURDAY: "土",
        JAN: "1月",
        FEB: "2月",
        MAR: "3月",
        APR: "4月",
        MAY: "5月",
        JUN: "6月",
        JUL: "7月",
        AUG: "8月",
        SEP: "9月",
        OTC: "10月",
        NOV: "11月",
        DEC: "12月"
    },
    _PAYGATE: {
        PAYMENT_THROUGH: "を通じて支払う",
        PAYMENT_METHOD: "支払い方法",
        ONLINE_PAYMENT_GATEWAY: "オンライン決済ゲートウェイ",
        CONFIGURATION: "設定",
        CONFIG_PAYMENT_GATE: "支払いゲートウェイ設定",
        HOTEL: "ホテル",
        TRANSFER_PAYMENT: "振込支払い",
        ONLINE_PAYMENT: "オンライン決済",
        PAYMENT_TYPE_EMPTY: "支払いタイプが存在しません",
        PAYMENT_METHOD_HAS_NOT_SELECTED: "支払い方法が選択されていません",
        PAYMENT_GATEWAY_IS_NOT_EXIST: "オンライン決済ゲートウェイが選択されていません",
        CASH: "現金払い",
        DEBT: "債務決済",
        PAYMENT_CARD: "クレジットカード"
    },
    NEAREST_POPULAR_LOCATION: "最寄りの人気スポット",
    MOST_POPULAR_LOCATION: "最も人気のある場所",
    RESTAURANT_AND_MARKET: "レストランと市場",
    TRAVEL_PLACE: "観光地",
    NEAREST_AIRPORT: "最寄りの空港",
    VIETNAMESE_NAME: "ベトナム名",
    ENGLISH_NAME: "英語名",
    ADD_LOCATION: "場所を追加",
    DISTANCE: "距離",
    ROOM_INFOMATION: "部屋情報",
    ROOM_AMENITIES: "部屋のアメニティ",
    ROOM_IMAGE: "部屋の写真",
    ROOM_NAME: "部屋タイプ",
    ROOM_TYPE: "部屋タイプ",
    MEAL: "食事",
    NAME_ROOM_TYPE: "部屋タイプ名",
    NAME_ROOM_TYPE_DEFAULT: "デフォルトのタイトル",
    TOTAL_ROOM: "部屋数",
    MAX_CUSTOMER_COUNT: "最大宿泊人数",
    ROOM_DIMENSION: "部屋サイズ",
    BED_BONUS_COUNT: "追加ベッド数",
    PRICE_NORMAL_DAY: "平日料金",
    PRICE_WEEKEND: "週末料金",
    ROOM_DIRECTION: "部屋の向き",
    BED_TYPE: "ベッドタイプ",
    ADULT: "大人",
    CHILDREN: "子供",
    ACTION: "アクション",
    COMMON_BED_TYPE: "一般的なベッドタイプ",
    COMBINATION_BED_TYPE: "ベッドタイプの組み合わせ",
    MORE_OPTIONS: "その他のオプション",
    REMOVE_OPTIONS: "オプションを削除",
    ADD_TYPE_BED: "ベッドタイプを追加",
    FREE: "無料",
    SURCHARGE: "追加料金",
    PACKAGE: "パッケージ",
    SELLING_PACKAGE_INFO: "料金プラン情報",
    SELLING_PACKAGE: "料金プラン",
    SERVICE_PACKAGE: "特典パッケージ",
    PROMOTION: "プロモーション",
    PROMOTION_INFO: "プロモーション情報",
    NAME_SELLING_PACKAGE: "料金プラン名",
    PACKEAGE_APPLY_FOR: "販売パッケージの適用先",
    MEALS_INCLUDE: "食事込み",
    EXTRA_BED_PRICE: "追加ベッド料金",
    EXTRA_ADULT_PRICE: "追加大人料金",
    EXTRA_CHILD_PRICE: "追加子供料金",
    MIN_NIGHT: "最低宿泊日数",
    MAX_NIGHT: "最大宿泊日数",
    DAYS_NOT_APPLY: "適用外日",
    NOT_APPLY: "適用外日",
    ADD_DAYS_NOT_APPLY: "追加適用外日",
    TYPE_ROOM_APPLIED: "適用部屋タイプ",
    PLAN_IS_SELECTING: "販売パッケージがOTAに接続されています",
    PLAN_NULL: "料金プランが存在しません",
    ERROR: "エラーが発生しました。もう一度お試しください。",
    COPY_SUCCESS: "コピー成功",
    COPPY_SUCCESS: "コピー成功",
    NOT_SELECTED_PLAN: "料金プランが選択されていません",
    NOT_SELECTED_ROOM: "部屋が選択されていません",
    MAX_STAY_NOT_SMALL_THAN_MIN_STAY: "最大宿泊日数は最低宿泊日数より少なくできません",
    CBALERT_LB_AVAISEARCH: "1つ以上を選択してください",
    PROMOTION_PACKAGE_NAME: "プロモーション名",
    PROMOTION_TYPE: "プロモーションタイプ",
    APPLY: "適用",
    APPLY_WITH: "適用対象",
    DISCOUNT_AND_SURCHARGES: "割引/追加料金率",
    DAYS_APPLY: "適用曜日",
    TIME_STAY: "宿泊日",
    TIME_SET: "予約日",
    TARGET_APPLY: "適用対象",
    ARGENT_LEVEL_APPLY: "エージェントレベルを選択",
    ARGENT_APPLY: "エージェントを選択",
    PACKAGE_APPLY: "料金プラン",
    X_DAYS: "x日間",
    FROM_DATE: "開始日",
    TO_DATE: "終了日",
    MIN_COUNT: "最小数",
    NIGHT_STAY: "宿泊日数",
    ROOM_BOOK_QUANTITY: "予約部屋数",
    QUANTITY_IS_FREE: "無料数量 (y)",
    COUPON: "クーポン",
    STATUS: "ステータス",
    ACTIVE: "アクティブ",
    DEACTIVE: "非アクティブ",
    STATE_ACTIVE_OR_DEACTIVE: "アクティブ/非アクティブ",
    CONTACT_BOOKING_DETAIL: "連絡先詳細",
    BOOKING_DETAIL: "予約詳細",
    NORMAL_ROOM_DETAIL: "基本部屋情報",
    VIP_ROOM_DETAIL: "VIP部屋情報",
    SERVICES: "サービス",
    PAYMENT_HISTORY: "支払い履歴",
    FILE_NAME: "ファイル名",
    FILE_TYPE: "ファイルタイプ",
    UPLOAD_BY: "アップロード者",
    FILE_CAPACITY: "ファイル容量",
    SIZE: "サイズ",
    UPLOAD_TIME: "アップロード日時",
    CLOSE: "閉じる",
    TOTAL: "合計",
    OR: "または",
    CHOOSE: "選択",
    NO_PHOTOS_FOUND: "写真が見つかりません",
    DRAG_DROP_PHOTOS_HERE: "ここに写真をドラッグ＆ドロップ",
    SELECT_PHOTOS_TO_UPLOAD: "アップロードする写真を選択",
    MAXIMUM_CAPACITY: "最大容量",
    LOADING: "読み込み中",
    EMAIL_CONFIGURATION: "メール設定",
    HOTEL_EMAIL: "ホテルメール",
    EMAIL_RECEIVE_BOOKING_ALERT_CC: "通知メール",
    EMAIL_CO_RECEIVE_BOOKING_ALERT_CC: "通知メール (CC)",
    EMAIL_RECEIVE_BOOKING_ALERT_BCC: "通知メール (BCC)",
    DISPLAY_LANGUAGE_AND_WEEKEND: "表示言語と週末",
    DISPLAY_LANGUAGE: "言語",
    WEEKEND: "週末",
    CURRENCY_AND_TAXES_FEES: "通貨および税金/手数料",
    CURRENCY_USED_IN_SYSTEM: "通貨",
    VAT_RATE_IS_APPLIES: "VAT％",
    SERVICE_TAX_RATE_APPLIES: "サービス料",
    PRICES_INCLUDE_TAXES_FEES: "料金に税金/手数料が含まれています",
    REGULATIONS_ON_CHILD_AGE_AND_ACCOMPANING_FEE: "子供の年齢および同伴料金規定",
    YOUTH_IS_FREE_OF_CHARGE: "幼児の最大年齢",
    AGE_CHILD_EXTRA_CHARGE: "子供の最大年齢",
    OTHER_INFOMATION: "その他の情報",
    CHECKIN_TIME: "チェックイン時間",
    CHECKOUT_TIME: "チェックアウト時間",
    YEAR_BUILT: "建築年",
    TOTAL_NUMBER_OF_FLOORS: "階数",
    DISTANCE_TO_AIRPORT: "空港までの距離",
    DISTANCE_TO_CITY_CENTER: "市中心までの距離",
    TIME_TO_AIRPORT: "空港までの時間（分）",
    VOLTAGE_USED: "使用電圧",
    ROOM_SERVICE: "ルームサービス",
    HOTEL_RULES: "ホテル規則",
    EFFECTIVE_DATE: "適用開始日",
    DEPOSIT_BEFORE_CHECKIN: "チェックイン前のデポジット",
    PERCENT: "割合",
    AMOUNT_OF_MONEY: "金額",
    PREPAYMENT_BEFORE_CHECKIN_DATE: "チェックイン前の支払い",
    PAYMENT_BEFORE_CHECKOUT_DATE: "チェックアウト時の支払い",
    PAYMENT_BEFORE_DAY_CHECKIN_DATE: "チェックイン時の支払い",
    ADD_NEW_PAYMENT_POLICY: "新しい支払いポリシーを追加",
    DEPOSIT_LEVEL_APPLIES: "デポジットレベル適用",
    TIME_APPLICATION: "宿泊日",
    CANCEL_ROOM_IN_ROUND_X_DAY_BEFORE_CHECKIN: "チェックインのx日前までに予約をキャンセル",
    FIXED_MONEY: "固定金額",
    ADD_NEW_CANCELLATION_POLICY: "新しいキャンセルポリシーを追加",
    FINES_APPLY: "罰金適用",
    PERSONAL_ACCOUNT_SETTING: "個人アカウント設定",
    LOG_OUT: "ログアウト",
    FEEDBACK_SUCCESS: "フィードバック成功",
    _LOGIN: {
        LOGIN: "ログイン",
        USERNAME: "ユーザー名",
        PASSWORD: "パスワード",
        FORGOT_PASSWORD: "パスワードをお忘れですか",
        REGISTER_NOW: "今すぐ登録",
        LOOKING_AGENT: "エージェントをお探しですか？",
        LOGIN_HERE: "ここでログイン",
        INVALID_ACCOUNT_INFO_MESSAGE: "ユーザー名またはパスワードが正しくありません！",
        SESSION_EXPIRED: "セッションが期限切れです！",
        HAS_NO_ACCESS: "ログインアカウントが無効です！",
        SESSION_EXPIRED_MESSAGE: "セキュリティ上の理由から、一定期間アクティビティがないとセッションが期限切れになります。続けるには、ユーザー名とパスワードを入力してログインしてください。",
        ARE_YOU_FORGOT_PASSWORD: "パスワードを忘れましたか？",
        ENTER_EMAIL_USERNAME: "パスワードをリセットするために、メールアドレスまたはユーザー名を入力してください！",
        EMAIL_USERNAME: "メールまたはユーザー名",
        EMAILADDRESS_ERROR_REQUIRED: "メールアドレスを再度確認してください！",
        EMAIL_NOT_EXIST: "メールまたはユーザー名が存在しません。もう一度お試しください！",
        REQUEST_RESET_PASS_NOTICE: "パスワードリセットリクエストが成功しました",
        SEND_NEW_PASS: "新しいパスワードが送信されました。メールを確認してください！",
        CANCEL: "キャンセル",
        RESET: "確認",
        HOTELID: "ホテルID",
        EZID_LOGIN: "ezIDでログイン"
    },
    _RESET: {
        NOT_VALID_REQUEST: "リセットリクエストが無効になりました"
    },
    _REGISTER: {
        OTA_GROUP: "販売チャネルグループ",
        OTA: "販売チャネル",
        WELCOME: "ezCrsへようこそ - 特にホテル向けに設計されています",
        SOLOGAN: "今すぐ登録して、最初から最後までサポートいたします。さまざまな商品を予約してお客様に販売できます。今すぐ参加してください！",
        PERSONAL_DETAIL: "個人情報",
        HOTEL_DETAIL: "ホテル情報",
        CREATE_ACCOUNT: "アカウントを作成",
        ENTER: "入力",
        HOTEL_EMAIL: "ホテルのメールアドレス",
        ENTER_EMAIL: "メールアドレスを入力",
        ENTER_TAX_CODE: "コードを入力",
        ENTER_ROOM_QUANTITY: "部屋数を入力",
        YOUR_COMPANY_NAME: "会社/ブランド名",
        YOUR_WEBSITE_LINK: "ホテルのウェブサイトリンク",
        SELECT: "選択",
        REQUIRED: "必須",
        FULLNAME: "氏名",
        YOUR_FULLNAME: "あなたの氏名",
        PERSONAL_PHONE: "個人電話番号",
        MALE: "男性",
        FEMALE: "女性",
        EMAIL: "メール",
        YOUR_EMAIL: "あなたのメールアドレス",
        POSITION: "役職/肩書",
        YOUR_POSITION: "あなたの役職/肩書",
        HOTEL_NAME: "ホテル名",
        HOTEL_TYPE: "ホテルタイプ",
        TAX_CODE: "税コード",
        COUNTRY: "国",
        WARD: "区",
        WEBSITE: "ウェブサイト",
        STAR: "星評価",
        CITY: "市/県",
        ADDRESS: "住所",
        HOTEL_PHONE: "ホテルの電話番号",
        NUMBER_OF_ROOMS: "部屋数",
        DISTRICT: "区/コミューン/特別区",
        USERNAME: "ユーザー名",
        CREATE_NEW_ACCOUNT_NAME: "新しいアカウント名を作成",
        PASSWORD: "パスワード",
        CREATE_PASSWORD: "パスワードを作成",
        RETYPE_PASSWORD: "パスワードを再入力",
        PASSWORD_NOT_MATCH: "パスワードが一致しません",
        PHONE_NUMBER_NOT_LESS_THAN: "電話番号は8文字以上である必要があります",
        PASSWORD_NOT_LESS_THAN: "パスワードは8文字以上である必要があります",
        VALID_USERNAME_MESSAGE: "英数字のみを含むユーザー名を選択してください",
        BY_CLICKING_REGISTER: "「登録」をクリックすると、以下に同意したことになります",
        TERM_AND_CONDITIONS: "利用規約",
        PRIVACY_POLICY: "プライバシーポリシー",
        AGREE_POLICY_MESSAGE: "「登録」をクリックすると、利用規約およびプライバシーポリシーに同意したことになります",
        THANKS_FOR_REGISTER: "登録ありがとうございます！",
        WAIT_APPROVE: "アカウントが作成され、承認待ちです。",
        UPLOAD_CERTIFICATE_MESSAGE: "アカウントを確認して発行するために、事業登録証をアップロードしてください。48時間以内に確認いたします。",
        REQUIRED_FIELD: "必須項目",
        ACCOUNT_ALREADY_EXISTS: "アカウントは既に存在します",
        REGISTER: "登録",
        NEXT: "次へ",
        BACK: "戻る",
        UPLOAD_FILE: "ファイルをアップロード",
        COMPLETE_AND_LOGIN: "完了してホームページに戻る"
    },
    _SUPPORT: {
        TITLE: "ウェブサイトへの予約エンジン統合手順"
    },
    _DASHBOARD: {
        TITLE: "ダッシュボード",
        IN_MONTH_REVENUE: "今月の収益（VND）",
        SEVEN_DAY_REVENUE: "過去7日間の収益（VND）",
        COLLECTION: "売掛金（VND）",
        ROOM_FILLING_RATE: "月間客室稼働率",
        BOOKING_EMPTY: "新しい予約がここに表示されます",
        BOOKING_TIME: "予約時間",
        BOOKING_CODE: "予約コード",
        AGENCY: "代理店",
        TIME_STAY: "宿泊日",
        PACKAGE: "サブスクリプションパッケージ",
        TOTAL: "合計（VND）",
        PAYMENT_STATUS: "支払い状況",
        BOOKING_NOT_PAYMENT: "未払いの予約",
        BOOKING_PART_PAYMENT: "部分的に支払われた予約",
        BOOKING_CANCELED: "顧客によってキャンセルされた予約",
        GO_TO_BOOKING_LIST: "予約一覧を見る",
        STATUS: "ステータス",
        HOTEL_STATUS: "ホテル情報",
        CONTRACT: "契約",
        DEBT: "負債",
        SYNC_PMS: "PMS同期",
        MISSING_INFO: {
            SYNC_OTA: "チャネル同期",
            SYNC_OTA_SUB_TITLE: "最低1チャネルのOTA同期",
            LIMITATIONS: "制限の宣言",
            RESTRICTION_SUB_TITLE: "少なくとも1つの制限を宣言",
            RATE_PLAN: "料金プラン、客室在庫の宣言",
            RATE_PLAN_SUB_TITLE: "最低値を1チャネルおよび客室在庫として宣言",
            TITLE: "必要な情報を完了",
            HOTEL_INFO: "ホテル情報",
            HOTEL_INFO_SUB_TITLE: "必須項目を記入",
            ROOM_TYPE: "部屋タイプ情報",
            ROOM_TYPE_SUB_TITLE: "少なくとも1部屋タイプを宣言",
            HOTEL_IMAGE: "ホテル写真",
            HOTEL_IMAGE_SUB_TITLE: "少なくとも1枚の画像をアップロード",
            ROOM_PRICE: "料金プラン",
            ROOM_PRICE_SUB_TITLE: "少なくとも1つの料金プランを宣言",
            HOTEL_SETTING: "ホテル設定",
            HOTEL_SETTING_SUB_TITLE: "必須項目を記入",
            BOOKING_CANCEL_POLICY: "キャンセルポリシー",
            BOOKING_CANCEL_POLICY_SUB_TITLE: "少なくとも1つのポリシーを宣言",
            PAYMENT_GATE: "支払いゲートウェイ",
            PAYMENT_GATE_SUB_TITLE: "少なくとも1つの支払い方法",
            CONTRACT: "契約",
            CONTRACT_SUB_TITLE: "必須項目を記入",
            PAYMENT_POLICY: "支払いポリシー",
            PAYMENT_POLICY_SUB_TITLE: "少なくとも1つのポリシーを宣言",
            CLOSE: "閉じる",
            ROOM_PLAN: "料金プラン",
            ROOM_PLAN_SUB_TITLE: "少なくとも1つの部屋販売パッケージを宣言",
            HOTEL_CONFIG: "ホテル構成",
            HOTEL_CONFIG_SUB_TITLE: "必須項目を記入"
        },
        CONFIRM: "確認",
        CONFIRM_SELL_ROOM: "入力したすべての情報が完全に正確であることを確認し、OneInventoryでの販売確認に同意します",
        CONFIRM_SELL_ROOM_BUTTON: "販売確認ボタン",
        _HOTEL_STATUS_INFO: {
            CREATE: "作成",
            WAIT_CONFIRM: "確認待ち",
            WAIT_APPROVE: "承認待ち",
            APPROVED: "承認済み",
            SENT_BACK: "差し戻し",
            ONSITE: "現地",
            OFFSITE: "現場外"
        },
        _HOTEL_STATUS_CONTRACT: {
            NOT_CREATED: "未作成",
            CREATE: "作成",
            RELEASED: "リリース済み",
            WAIT_SIGN: "署名待ち",
            COMPLETED: "完了",
            SIGNED: "署名済み",
            IN_DISPUTE: "紛争中",
            LIQUIDATED: "清算済み",
            CLOSED: "終了"
        },
        _HOTEL_STATUS_DEBT: {
            NOT_CONFIGURED: "未設定",
            CONFIGURED: "設定済み"
        },
        _HOTEL_STATUS_SYNC_PMS: {
            SYNCHRONIZED: "同期済み",
            UNSYNCHRONIZED: "未同期",
            RECEIVED: "受領済み",
            NOT_RECEIVED: "未受領"
        }
    },
    _BATCH_UPDATE: {
        TITLE: "一括更新",
        ADD: "追加",
        SELECT_ROOM_TYPE: "部屋タイプを選択",
        SELECT_UPDATE_TYPE: "更新タイプを選択",
        ALL_ROOM: "すべての部屋",
        AVAILABLE_ROOM: "在庫",
        PRICE: "価格",
        STOP_SELL: "販売停止",
        CTA: "到着禁止",
        CTD: "出発禁止",
        MIN_NIGHT_STAY: "最低宿泊数",
        MAX_NIGHT_STAY: "最大宿泊数",
        ROOM_TYPE_AND_SALE_PACKAGE: "部屋タイプ / 料金プラン",
        FROM: "開始",
        TO: "終了",
        MESSAGE: {
            OVERLAP_TIME: "更新間隔が重複できません"
        },
        APPLY: "適用",
        DELETE_STOP_SELL: "販売停止を削除",
        DELETE_CTA: "到着禁止を削除",
        DELETE_CTD: "出発禁止を削除"
    },
    _BOOKING: {
        TITLE: "予約一覧",
        BOOKING: "0 件の予約 | 1 件の予約 | {count} 件の予約",
        BOOKING_DATE: "予約日",
        BOOKING_CODE: "予約コード",
        REQUEST_CODE: "リクエストコード",
        REQUEST_DATE: "リクエスト日",
        REQUEST_STATUS: "リクエストステータス",
        AGENT_NAME: "代理店",
        TIME_STAY: "宿泊日",
        COMBO: "サブスクリプションパッケージ",
        COMBO_REQUEST: "パッケージリクエスト",
        AMOUNT: "合計金額",
        BOOKING_STATUS: "予約ステータス",
        EXPORT: "Excel エクスポート",
        SEARCH: "検索",
        RESET: "リセット",
        ENTER_BOOKING_CODE: "予約コードを入力",
        ENTER_BOOKING_CODE_OTA: "OTA予約コードを入力",
        ENTER_BOOKING_GROUP_CODE: "グループ予約コードを入力",
        SEARCH_CONDITION: "検索条件",
        SEARCH_BOOKING_CODE: "予約コード",
        SEARCH_DATE: "日付範囲を選択",
        EDIT: "編集",
        CONFIRM_FEEDBACK: "代理店にリクエスト送信を確認",
        CONFIRM_FEEDBACK_REASON: "フィードバック内容",
        SEARCH_BY: {
            BOOKING_CODE: "予約コード",
            REQUEST_DATE: "リクエスト日",
            BOOKING_DATE: "予約日",
            CHECKIN_DATE: "チェックイン日",
            CHECKOUT_DATE: "チェックアウト日",
            STAYING_DATE: "宿泊日"
        },
        STATUS: {
            ALL: "すべて",
            CANCEL: "お客様によるキャンセル",
            AWAIT_PAYMENT: "支払い待ち",
            CLOSE: "クローズ",
            IN_SERVICE: "サービス中",
            PAYMENT_FAILED: "支払い失敗",
            CONFIRM: "確認済み",
            AWAIT_FULLY_PAYMENT: "部分支払い",
            VOID: "ホテルによるキャンセル",
            STATUS_WAIT_FEEDBACK: "フィードバック待ち",
            STATUS_FEEDBACK: "フィードバック",
            STATUS_COMPLETE: "完了",
            STATUS_CANCEL: "キャンセル"
        },
        SEARCH_PMS_STATUS: "同期ステータス",
        SEARCH_PMS_CODE: "PMSタイプ",
        CHECKIN_STATUS: "チェックインステータス",
        AGENT: "TA",
        MARKET: "市場セグメント",
        PDF: "PDFエクスポート",
        UNMAP_BOOKING: {
            UNMAP_BOOKING_TITLE: "Mapping status",
            ALL: "All",
            MAPPED: "Mapped",
            UNMAP_ROOM_TYPE: "Unmapped room",
            UNMAP_RATE_PLAN: "Unmapped rate",
            UNMAP_ROOMRATE: "Unmapped room_rate",
        }
    },
    _BOOKING_DETAIL: {
        TITLE: "予約詳細",
        CONTACT: {
            TITLE: "連絡先",
            NAME: "ゲスト名",
            PHONE: "電話番号",
            EMAIL: "メールアドレス",
            GROUP_NAME_TOUR: "グループ名",
            AGENT_NAME: "代理店"
        },
        BOOKING_DETAIL: {
            TITLE: "予約情報",
            CODE: "予約コード",
            OTACODE: "OTA予約コード",
            STATUS: "予約ステータス",
            CREATED: "予約日",
            CHECK_IN: "チェックイン日",
            CHECK_OUT: "チェックアウト日",
            UPDATED: "更新日",
            NOTE: "メモ"
        },
        ROOM: {
            TITLE: "部屋詳細 -",
            APPLY_DATE: "日付",
            NAME: "料金プラン",
            UNIT_PRICE: "1泊あたりの価格 (VND)",
            QUANTITY: "部屋数",
            ADULTS: "大人",
            CHILDREN: "子供",
            BABY: "乳児",
            TOTAL: "金額 (VND)"
        },
        PROMOTION_ONEI: {
            TITLE: "プロモーション在庫",
            NAME: "プロモーション名",
            COST_TYPE: "費用タイプ",
            TOTAL: "金額 (VND)"
        },
        PROMOTION: {
            TITLE: "プロモーション",
            NAME: "プロモーション名",
            ROOM_PLAN_NAME: "料金プラン",
            ROOM_NAME: "部屋タイプ",
            TOTAL: "金額 (VND)"
        },
        SERVICE: {
            TITLE: "サービス",
            NAME: "サービス名",
            DATE: "利用日",
            COST: "料金",
            COUNT: "数量",
            TOTAL: "金額 (VND)"
        },
        PAYMENT_LOG: {
            TITLE: "支払い履歴",
            METHOD: "支払い方法",
            AMOUNT: "金額",
            TRANS_NO: "取引コード",
            TRANS_DATE: "取引日",
            RES_CODE: "結果",
            RES_MSG: "メモ"
        },
        METHOD_NAME: {
            ONEPAY_DOM: "国内Onepay支払い",
            ONEPAY_INTER: "国際Onepay支払い",
            VNPAY: "Vnpay支払い",
            TRANSFER: "振込支払い",
            CASH: "現金支払い",
            VNPAY_QR: "Vnpay QR支払い",
            VIETTELPAY_QR: "Viettelpay QR支払い",
            VIETTELPAY: "Viettelpay支払い"
        },
        PAYMENT_CARD_DETAIL: "支払いカード詳細",
        SUB_TOTAL: "小計",
        TOTAL: "合計金額",
        PAID: "支払い済み金額：",
        UNPAID: "未払い金額：",
        EXPORT: "予約を印刷",
        CANCEL: "予約をキャンセル",
        NOTE: "メモ",
        CONFIRM_CANCEL: "予約キャンセルを確認しますか？",
        CONFIRM_REASON: "理由（必須）",
        CONFIRM: "確認",
        COMMISSION: "手数料",
        BEFORE_COMMISSION: "受領金額",
        AFTER_COMMISSION: "手数料込み価格",
        PAYMENT_COLLECT: "支払い収集",
        PROPERTY_COLLECT: "物件収集",
        OTA_CONTACT: "OTA 連絡先",
        CHANNEL_COLLECT: "チャネル収集"
    },
    _REQUEST_DETAIL: {
        TITLE: "リクエスト詳細",
        BUGET: "支払済予算",
        CONTACT: {
            TITLE: "予約連絡先詳細",
            NAME: "ゲスト名",
            PHONE: "電話番号",
            EMAIL: "メールアドレス",
            AGENT_NAME: "代理店",
            REQUESTER_NAME: "リクエスト者名"
        },
        BOOKING_DETAIL: {
            TITLE: "リクエスト詳細",
            CODE: "リクエストコード",
            STATUS: "リクエストステータス",
            CREATED: "リクエスト日",
            CHECK_IN: "チェックイン日",
            CHECK_OUT: "チェックアウト日",
            UPDATED: "更新日"
        },
        ROOM: {
            TITLE: "部屋詳細",
            APPLY_DATE: "日付",
            NAME: "料金プラン",
            UNIT_PRICE: "1泊あたりの価格 (VND)",
            QUANTITY: "部屋数",
            ADULTS: "大人",
            CHILDREN: "子供",
            TOTAL: "金額 (VND)"
        },
        NOTE: "メモ",
        SEND_REQUEST: "フィードバック"
    },
    _BOOKING_TRANSACTION: {
        TITLE: "収支取引",
        ALL: "すべて",
        BOOKING: "部屋予約",
        BOOKING_DATE: "予約日",
        BOOKING_CODE: "予約コード",
        AGENT_NAME: "代理店",
        TIME_STAY: "宿泊日",
        AMOUNT: "合計金額",
        PAYMENT_DATE: "支払日",
        BOOKING_STATUS: "予約ステータス",
        ACTION: "操作",
        EXPORT: "Excelエクスポート",
        SEARCH: "検索",
        CONFIRM: "確認",
        TIME_STAY_TEXT: "{day}日間 {night}泊",
        SEARCH_CONDITION: "検索条件",
        SEARCH_BOOKING_CODE: "コードを入力",
        SEARCH_DATE: "日付範囲",
        SEARCH_BY: {
            BOOKING_CODE: "予約コード",
            BOOKING_DATE: "予約日",
            CHECKIN_DATE: "チェックイン日",
            CHECKOUT_DATE: "チェックアウト日"
        },
        STATUS: {
            CANCEL: "お客様によるキャンセル",
            AWAIT_PAYMENT: "支払い待ち",
            CLOSE: "クローズ",
            IN_SERVICE: "サービス中",
            PAYMENT_FAILED: "支払い失敗",
            CONFIRM: "確認済み",
            AWAIT_FULLY_PAYMENT: "部分支払い",
            VOID: "ホテルによるキャンセル"
        }
    },
    _BOOKING_TRANSACTION_DETAIL: {
        TITLE: "取引詳細",
        DETAIL: "取引詳細",
        BOOKING_CODE: "予約コード：",
        PAYMENT_METHOD: "支払い方法",
        TRANSACTION_CODE: "取引コード",
        TRANSACTION_DATE: "取引日",
        AMOUNT: "金額",
        NOTE: "メモ",
        BANK_TRANSFER: "振込",
        CASH: "現金",
        DEBT: "負債"
    },
    _ROOM_PLAN: {
        TITLE: "部屋と料金プラン",
        BATCH_UPDATE: "一括更新",
        ALL_ROOM: "すべての部屋",
        STOP_SELL: "販売停止",
        MIN_STAY: "最短宿泊日数",
        MAX_STAY: "最長宿泊日数",
        CTA: "到着制限",
        CTD: "出発制限",
        CURRENT_MONTH: "{month}/{year}",
        CONFIRM_CHANGE_PAGE: "未保存のデータが失われます\n続行しますか？",
        MIN_SMALLER_THAN_ONE: "最短宿泊日数は1未満にはできません",
        MAX_SMALLER_THAN_ONE: "最長宿泊日数は1未満にはできません",
        MIN_BIGGER_THAN_MAX: "最短宿泊日数が最長宿泊日数より多い",
        MIN_SMALLER_THAN_CONFIG: "最短宿泊日数が設定された最短宿泊日数より少ない",
        MAX_BIGGER_THAN_CONFIG: "最長宿泊日数が設定された最長宿泊日数より多い"
    },
    SALE_PACKAGE: "料金プラン",
    _HOTEL_CHAIN: {
        CHAIN_LIST_HOTEL: "ホテル",
        TITLE: "ホテルチェーン",
        CHAIN_NAME: "チェーン名",
        CHAIN_LIST: "ホテルリスト ({total})",
        HOTEL_ID: "ホテルID：",
        ADD_HOTEL: "ホテルを追加",
        LOGIN_TEXT: "ホテルを変更するには、ホテルオーナーのアカウントでログインしてください",
        LOGIN_EXISTED_TEXT: "アカウントログイン {hotelName}：",
        USERNAME: "ユーザー名",
        PASSWORD: "パスワード",
        CONFIRM: "確認",
        REMOVE_HOTEL: "選択したホテルをチェーンから削除してもよろしいですか？",
        LOGIN: "ログイン",
        DELETE_HOTEL: "チェーンから削除",
        LABEL_SEARCH_CODE_NAME: "ホテルコード/名前",
        ENTER_HOTEL_NAME_OR_CODE: "ホテル名またはホテルコードを入力",
        CHAIN_LIST_BOOKING: "予約",
        STATUS: "ステータス",
        SEARCH: "検索"
    },
    _ACCOUNT_SETTING: {
        TITLE: "個人アカウント設定",
        AVATAR: "アバター",
        USER_INFO: "個人情報",
        CHANGE_PASSWORD: "パスワード変更",
        USERNAME: "ユーザー名",
        FULLNAME: "氏名",
        PASSWORD: "パスワード",
        PASSWORD_REPEAT: "パスワード確認",
        GENDER: "性別",
        GENDER_MALE: "男性",
        GENDER_FEMALE: "女性",
        EMAIL: "メール",
        PHONE_NUMBER: "電話番号",
        ADDRESS: "住所",
        POSITION: "役職",
        GROUP: "ユーザーグループ",
        CURRENT_PASS: "現在のパスワード",
        NEW_PASS: "新しいパスワード",
        NEW_PASS_REPEAT: "新しいパスワードを再入力",
        ERROR_PHONE_NUMBER_MIN: "電話番号は8文字以上でなければなりません",
        ERROR_PASSWORD_MIN: "パスワードは8文字以上で入力してください",
        ERROR_RETYPE_PASSWORD_MIN: "確認パスワードも8文字以上で入力してください",
        ERROR_PASSWORD_INVALID: "現在のパスワードが正しくありません",
        ERROR_PASSWORD_NOT_MATCH: "パスワードが一致しません",
        MESSAGE_PASSWORD_MATCHED: "パスワードが一致しました",
        MESSAGE_PASSWORD_NOT_MATCHED: "パスワードが一致していません"
    },
    _LIST_USER: {
        TITLE: "ユーザー管理",
        LIST_USER: "ユーザー",
        USER: "ユーザー",
        SEARCH_PLACEHOLDER: "ユーザー名、氏名、またはメールで検索",
        GROUP_NAME: "グループ名",
        USERNAME: "ユーザー名",
        NAME: "氏名",
        EMAIL: "メール",
        CREATE_USER: "作成者",
        CREATE_DATE: "作成日",
        STATUS: "ステータス",
        ACTION: "アクション",
        STATUS_ACTIVATE: "有効",
        STATUS_DEACTIVATE: "無効",
        REMOVE: "このユーザーを削除しますか？",
        CANNOT_DELETE_CURRENT_USER: "現在のユーザーは削除できません"
    },
    _LIST_GROUP: {
        TITLE: "ユーザーグループ管理",
        LIST_GROUP: "ユーザーグループ",
        GROUP: "ユーザーグループ",
        SEARCH_PLACEHOLDER: "ユーザーグループ名で検索",
        GROUP_NAME: "グループ名",
        CREATE_USER: "作成者",
        CREATE_DATE: "作成日",
        STATUS: "ステータス",
        ACTION: "アクション",
        STATUS_ACTIVATE: "有効",
        STATUS_DEACTIVATE: "無効",
        DESCRIPTION: "説明",
        REMOVE: "このグループを削除しますか？"
    },
    _EDIT_USER: {
        TITLE: "ユーザー情報",
        INFO: "ユーザー情報",
        USER: "ユーザー",
        ROLE: "アクセス権限",
        USERNAME: "ユーザー名",
        FULLNAME: "氏名",
        PASSWORD: "パスワード",
        PASSWORD_REPEAT: "パスワード確認",
        GENDER: "性別",
        GENDER_MALE: "男性",
        GENDER_FEMALE: "女性",
        EMAIL: "メール",
        PHONE_NUMBER: "電話番号",
        ADDRESS: "住所",
        POSITION: "役職",
        GROUP: "ユーザーグループ",
        GROUP_PLACEHOLDER: "検索",
        HOTEL_OWNER: "ホテルオーナー",
        STATUS: "ステータス (有効/無効)",
        N_O: "番号",
        FUNCTION_CODE: "機能コード",
        FUNCTION_NAME: "機能名",
        ACTION: "アクション",
        ERROR_PHONE_NUMBER_MIN: "電話番号は8文字以上で入力してください",
        ERROR_PASSWORD_MIN: "パスワードは8文字以上で入力してください",
        ERROR_RETYPE_PASSWORD_MIN: "確認パスワードも8文字以上で入力してください",
        ERROR_PASSWORD_NOT_MATCH: "パスワードが一致しません",
        CHAIN: "チェーン",
        HOTEL: "ホテル"
    },
    _EDIT_GROUP: {
        TITLE: "ユーザーグループ情報",
        INFO: "ユーザーグループ情報",
        GROUP: "ユーザーグループ",
        ROLE: "アクセス権限",
        GROUP_NAME: "グループ名",
        GROUP_CODE: "グループコード",
        GROUP_ROLE: "グループ役割",
        PARENT_GROUP: "親グループ",
        TYPE: "グループタイプ",
        DESCRIPTION: "説明情報",
        STATUS: "ステータスアクティブ/非アクティブ",
        NO: "STT",
        FUNCTION_CODE: "機能コード",
        FUNCTION_NAME: "機能名",
        ACTION: "アクション",
        ERROR_MIN_ROLE_SELECTED: "少なくとも1つの機能画面を選択してください"
    },
    _CONTRACT: {
        TITLE: "電子契約",
        CONTRACT_INFO: "法的情報",
        BUSINESS_NAME: "会社名",
        BUSINESS_NAME_NOTE: "（ビジネスライセンスに正しく記入、大文字）",
        TAX_CODE: "税コード",
        TAX_CODE_NOTE: "（正しく入力し、すべてのゼロを含む）",
        ADDRESS: "登録済み事業住所",
        ADDRESS_NOTE: "（GPKDに従って記入）",
        BANK_ACCOUNT: "銀行口座番号",
        BANK_ACCOUNT_OWNER: "銀行口座名義人",
        BANK: "銀行名",
        BANK_BRANCH: "銀行支店",
        LEGAL_REPRESENTATIVE: "法定代表者",
        LEGAL_REPRESENTATIVE_NOTE: "（GPKDに従って記入）",
        PIC: "契約署名者",
        PIC_POSITION: "署名者の役職",
        COMMISSION: "手数料（%）",
        STATUS: "契約ステータス",
        VIEW: "表示",
        _STATUS: {
            CREATE: "作成",
            AM_SENT: "AM送信済み",
            SM_ACCEPT: "SM承認",
            SM_REJECT: "SM拒否",
            CM_ACCEPT: "CM承認",
            CM_REJECT: "CM拒否",
            PUBLISH: "公開",
            WAIT_SIGN: "署名待ち",
            COMPLETE: "完了",
            SIGNED: "署名済み",
            DISPUTED: "紛争中",
            LIQUIDFY: "清算",
            CLOSE: "終了",
            EXTEND: "延長"
        }
    },
    _TRAVEL_AGENT: {
        TITLE: "代理店リスト",
        TITLE_DEACTIVE: "協力を停止した代理店リスト",
        AGENT: "代理店",
        SEARCH_PLACEHOLDER: "代理店名で検索",
        NAME: "代理店名",
        BUSINESS_TYPE: "業種",
        TAX_CODE: "税コード",
        LEVEL: "代理店分類",
        STATUS: "ステータス",
        DEACTIVE: "リンク解除",
        ACTIVE: "リンクに戻す",
        LEVEL_1: "レベル 1",
        LEVEL_2: "レベル 2",
        LEVEL_3: "レベル 3",
        LEVEL_4: "レベル 4",
        LEVEL_5: "レベル 5",
        CONFIRM_CHANGE_LEVEL: "レベル変更を確認しますか？",
        CONFIRM_ACTIVE: "代理店との提携を確認しますか？",
        CONFIRM_DEACTIVE: "代理店のリンク解除を確認しますか？",
        CONFIRM_REASON: "理由（必須）",
        CONFIRM: "確認"
    },
    _VALIDATE: {
        REQUIRED: "すべての必要な情報を入力してください",
        EMAIL_FORMAT: "メール形式を確認してください",
        MIN_LENGTH: "入力値は{minLength}文字以上でなければなりません",
        MAX_LENGTH: "入力値は{maxLength}文字以下でなければなりません",
        REQUIRED_AT_LEAST_ONE_HOTEL_OR_CHAIN: "ユーザーには少なくとも1つのチェーンまたはホテルを選択してください"
    },
    _ROLES: {
        CHAIN: "チェーンメニュー",
        BOOKING_CHAIN: "チェーンとホテルの予約",
        CHAIN_LIST: "チェーンリスト",
        USER_MANAGEMENT: "ユーザー管理",
        DASHBOARD: "ダッシュボード",
        MANAGE: "管理",
        BOOKING_HOTEL: "単一ホテルの予約",
        ROOM_SALE: "部屋販売",
        ROOM_SALE_MANAGEMENT: "部屋販売管理",
        SALE_PACKAGE_MANAGEMENT: "料金プラン管理",
        OTA_MANAGEMENT: "ezCms Vela",
        SETTING: "設定",
        ACCOUNT_INFOMATION: "アカウント設定",
        PERSONAL_ACCOUNT: "個人アカウント情報",
        GENERAL_INFORMATION: "一般情報",
        HOTEL_AMENITY: "ホテルアメニティ",
        HOTEL_IMAGE: "ホテル画像",
        NEARBY_PLACE: "近隣の場所",
        ROOM_TYPE: "部屋タイプ",
        ROOM_INFORMATION: "部屋情報",
        ROOM_AMENITY: "部屋アメニティ",
        ROOM_IMAGE: "部屋画像",
        HOTEL_CONFIGURATION: "ホテル構成",
        GENERAL_CONFIGURATION: "一般設定",
        PAYMENT_POLICY: "支払いポリシー",
        CANCELLATION_POLICY: "キャンセルポリシー",
        IMAGE_LIBRARY: "画像ライブラリ",
        HISTORY_LOG: "履歴ログ",
        PAYMENT_METHOD: "支払い方法",
        BOOKING_ENGINE: "予約エンジン",
        BOOKING_ENGINE_CONFIG: "設定",
        HOTEL_EMAIL: "メール",
        HOTEL_BOOKING_CONFIRM: "予約確認",
        HOTEL_SERVICE: "サービス",
        HOTEL_PROMOTION: "プロモーション",
        HOTEL_INFORMATION: "ホテル情報",
        BOOKING_MANAGEMENT: "予約管理",
        SYNC_MANAGEMENT: "チャネル同期",
        HEADER_FOOTER: "テンプレート",
        SU_MANAGEMENT: "ezCms Leo",
        SU_CONNECTION: "販売チャネル",
        SU_MAPPING: "マッピング",
        HOTEL_BOOKING_REPOST: "予約の再投稿",
        CHAIN_SERVICE: "サービス",
        CHAIN_ROOM_TYPE: "部屋タイプ情報",
        CHAIN_RATE_PLAN: "部屋販売パッケージ",
        CHAIN_TRAVEL_AGENT: "企業および代理店情報",
        HOTEL_TRAVEL_AGENT: "企業および代理店情報",
        SITEMINDER_MANAGEMENT: "ezCms SiteMinder",
        GDS_MANAGEMENT: "ezCms GDS",
        RMS_MANAGEMENT: "収益管理",
        DYNAMIC_PRICING: "動的料金",
        MASTER_RATE: "マスターレート",
        PACKAGE_MANAGEMENT: "パッケージ取引",
        PACKAGE_ITEM: "パッケージ項目",
        PACKAGE_DEAL: "パッケージ取引",
        BE_MANAGEMENT: "ezBe",
        HOTEL_BOOKING_GROUP: "予約グループ",
        BOOKING_UNMAP_HOTEL: "予約のマッピング解除",
        HOTEL_DASHBOARD_IGNORE_TASK: "無視",
        HOTEL_DASHBOARD_REUPDATE_TASK: "再更新",
        HOTEL_BOOKING_UNMAP_REPOST: "予約の再投稿",
        CHAIN_ROOM_UPDATE_QUANTITY: "部屋数の更新",
        HOTEL_DASHBOARD: "ダッシュボード",
        ROOM_UPDATE_QUANTITY: "部屋数の更新",
        DYNAMIC_RESTRICTION: "動的制限",
        DYNAMIC_ROOM_SALE: "動的部屋販売",
        DYNAMIC_CONFIGURATION: "構成",
        CHAIN_BOOKING_REPOST: "予約の再投稿",
        INVENTORY: "在庫",
        RATE: "価格",
        RESTRICTION: "制限",
        STOP_SELL_LIMIT: "販売制限",
        CHANNEX_MANAGEMENT: "ezCms Vela+",
        CHANNEX_CONNECTION: "販売チャネル",
        CHANNEX_MAPPING: "マッピング",
        WARNING_METHOD: "警告方法",
        STAAH_MANAGEMENT : "ezCms StaahMax",
        STAAH_MAPPING: "マッピング",
        STAAH_CONNECTION: "販売チャネル",
    },
    _LEFT_MENU: {
        COPY_RIGHT: "Copyright © 2021 ezCloud 全著作権所有"
    },
    _ACTIVITY: {
        ACTION_DATE: "アクション日",
        ACTION_BY: "実施者",
        APPLY_DATE: "適用日",
        CREATED_DATE: "作成日",
        ROOM_NAME: "部屋名",
        RATE: "料金",
        CREATE_DATE: "作成日",
        SEARCH_DATE: "適用日",
        USER_NAME: "アカウント",
        ROOM: "部屋",
        ROOM_PLAN: "料金プラン",
        YES: "はい",
        NO: "いいえ",
        STOPSELL: "販売停止",
        MINSTAY: "最小滞在",
        CLOSEDTOARRIVE: "到着不可",
        MAXSTAY: "最大滞在",
        CLOSEDTODEPATURE: "出発不可",
        IPADDRESS: "IPアドレス",
        CREATEDBY: "作成者",
        PAGING: "ページ",
        DOCUMENT: "記録",
        ROOMAVAIL: "在庫",
        ALLSELECT: "全て選択",
        HOTELID: "ホテルID",
        HOTELNAME: "ホテル名",
        DATABEFORE: "以前のデータ",
        DATAAFTER: "以降のデータ",
        ACTION: "アクション",
        HOTEL_LOGIN: "ログイン",
        HOTEL_CANCEL_BOOKING: "予約キャンセル",
        HOTEL_UPDATE_PAYMENT_BOOKING: "予約確認",
        HOTEL_REQUEST_BOOKING: "リクエスト予約確認",
        HOTEL_ROOM_PLAN_CREATE: "新しい料金プラン",
        HOTEL_ROOM_PLAN_UPDATE: "料金プラン情報",
        HOTEL_ROOM_PLAN_COPY: "プランをコピー",
        HOTEL_ROOM_PLAN_DELETE: "プランを削除",
        HOTEL_PROMOTION_CREATE: "新しいプロモーション",
        HOTEL_PROMOTION_UPDATE: "プロモーション情報",
        HOTEL_PROMOTION_COPY: "プロモーションをコピー",
        HOTEL_PROMOTION_DELETE: "プロモーションを削除",
        HOTEL_PROFILE_UPDATE: "プロファイルを更新",
        HOTEL_AVATAR_ADD: "アバターを追加",
        HOTEL_AVATAR_REMOVE: "アバターを削除",
        HOTEL_CHANGE_PASSWORD_PROFILE: "パスワードを変更",
        HOTEL_USER_CREATE: "ユーザーを作成",
        HOTEL_USER_UPDATE: "ユーザーを更新",
        HOTEL_USER_UPDATE_ROLE: "ユーザーロールを更新",
        HOTEL_USER_DELETE: "ユーザーを削除",
        HOTEL_GROUP_CREATE: "グループユーザーを作成",
        HOTEL_GROUP_UPDATE: "グループユーザーを更新",
        HOTEL_GROUP_UPDATE_ROLE: "グループユーザーロールを更新",
        HOTEL_GROUP_DELETE: "グループユーザーを削除",
        HOTEL_CONTRACT_UPDATE: "契約を更新",
        HOTEL_INFO_UPDATE: "ホテル情報を更新",
        HOTEL_UPDATE_AMENITIES: "ホテルアメニティを更新",
        HOTEL_UPDATE_IMAGES: "新しい画像を追加",
        HOTEL_DELETE_IMAGES: "画像を削除",
        HOTEL_AREA_CREATED: "近隣エリアを作成",
        HOTEL_AREA_UPDATED: "近隣エリアを更新",
        HOTEL_AREA_DELETED: "近隣エリアを削除",
        HOTEL_CHAIN_CREATED: "ホテルチェーンを作成",
        HOTEL_CHAIN_UPDATED: "ホテルチェーンを更新",
        HOTEL_ROOM_CREATED: "部屋を作成",
        HOTEL_ROOM_UPDATED: "部屋を更新",
        HOTEL_ROOM_COPY: "部屋をコピー",
        HOTEL_ROOM_DELETED: "部屋を削除",
        HOTEL_ROOM_AMENITY: "部屋アメニティを更新",
        HOTEL_ROOM_ADD_IMAGES: "部屋画像を追加",
        HOTEL_ROOM_DELETE_IMAGES: "部屋画像を削除",
        HOTEL_UPDATE_HOTEL_SETTING_INFO: "ホテル設定を更新",
        HOTEL_PAYMENT_POLICY_CREATED: "支払いポリシーを作成",
        HOTEL_PAYMENT_POLICY_UPDATED: "支払いポリシーを更新",
        HOTEL_PAYMENT_POLICY_DELETED: "支払いポリシーを削除",
        HOTEL_CANCEL_POLICY_CREATED: "キャンセルポリシーを作成",
        HOTEL_CANCEL_POLICY_UPDATED: "キャンセルポリシーを更新",
        HOTEL_CANCEL_POLICY_DELETED: "キャンセルポリシーを削除",
        HOTEL_SETTING_PAYMENT_GATE: "支払いゲートを設定",
        HOTEL_ADD_IMAGES_SLIDE: "スライド画像を追加",
        HOTEL_DELETE_IMAGES_SLIDE: "スライド画像を削除",
        HOTEL_REMOVE_CONNECT_AGENT: "エージェント接続をキャンセル",
        HOTEL_UPDATE_LEVEL_AGENT: "エージェント接続レベルを更新",
        HOTEL_RETURN_CONNECT_AGENT: "エージェント接続を復元",
        PMS_CONFIRM: "PMS確認",
        RATE_CATEGORY_CREATE: "新しい料金カテゴリーを作成",
        RATE_CATEGORY_UPDATE: "料金カテゴリー詳細",
        ROOM_CATEGORY_CREATE: "新しい部屋カテゴリーを作成",
        ROOM_CATEGORY_UPDATE: "部屋カテゴリー詳細"
    },
    STATUS_CREATE_NEW: "新規作成",
    STATUS_DELIVERED: "配信済み",
    STATUS_SALE_SEND_HOTEL: "ホテルに送信",
    STATUS_SALE_ADMIN_SEND_BACK: "SMが返送",
    STATUS_SALE_ADMIN_PASSED: "SMが承認",
    STATUS_QC_SENT_BACK_HOTEL: "QCが返送",
    STATUS_QC_PASSED_HOTEL: "QCが承認",
    STATUS_SALE_ADDITIONAL: "情報送信",
    STATUS_QC_SENT_BACK_INFOR: "情報を返送",
    STATUS_QC_PASSED_INFOR: "情報を承認",
    STATUS_ONSITE: "現地",
    STATUS_OFFSITE: "現場外",
    STATUS_SIGNED: "署名済み",
    STATUS_WAITING_SIGN: "署名待ち",
    STATUS_CLOSED: "終了",
    STATUS_IN_DISPUTE: "紛争中",
    STATUS_LIQUIDATED: "清算済み",
    STATUS_COMPLETED: "完了",
    STATUS_CM_PASSED: "CM通過",
    STATUS_CM_SEND_BACK: "CM送信戻し",
    STATUS_RELEASED: "リリース済み",
    STATUS_RENEWAL: "更新",
    STATUS_CHANGED: "ステータスが変更されました",
    STATUS_NEW_CREATE: "新規作成",
    STATUS_AWAIT_PAYMENT: "支払い待ち",
    STATUS_AWAIT_FULLY_PAYMENT: "全額支払い待ち",
    STATUS_PAYMENT_FAILED: "支払い失敗",
    STATUS_CONFIRM: "確認",
    ALL: "すべて",
    CANCEL: "顧客によってキャンセルされました",
    AWAIT_PAYMENT: "支払い待ち",
    IN_SERVICE: "サービス中",
    PAYMENT_FAILED: "支払い失敗",
    CONFIRM: "確認済み",
    AWAIT_FULLY_PAYMENT: "部分支払い",
    VOID: "ホテルによってキャンセルされました",
    STATUS_WAIT_FEEDBACK: "フィードバック待ち",
    STATUS_FEEDBACK: "フィードバック",
    STATUS_COMPLETE: "完了",
    STATUS_CANCEL: "キャンセル",
    BOOKING: "予約",
    BOOKING_STATUS: "予約のステータス",
    BOOKING_REQUEST_STATUS: "送信リクエストのステータス",
    CONTRACT_STATUS: "契約ステータス",
    TA_STATUS: "旅行代理店ステータス",
    HOTEL_STATUS: "ホテルステータス",
    SHOW_MORE: "もっと見る",
    NOTIFICATION: "通知",
    HAS_JUST_JOINED_ONEI: "One Inventoryに参加しました",
    HAS_JUST_CREATED_ONEI: "OneInventory.comで作成しました",
    ANNEX_OF_CONTRACT: "契約書の付録番号",
    YOUR_AGENT: "あなたの代理店",
    NOTIFICATIONS: "通知",
    MARK_AS_READ: "既読にする",
    CONTACT_NUMBER: "契約番号",
    HOTELS_CONTRACT: "ホテルの契約",
    AGENTS_CONTRACT: "代理店の契約",
    ADDENDUM_OF_CONTRACT: "追加契約書番号",
    EXTEND_CONTRACT: "契約を延長する",
    BELONG_HOTEL: "ホテルの",
    BELONG_AGENT: "代理店の",
    AGENT: "代理店",
    NEW_TA: "新しい代理店",
    RE_RELEASE: "再リリース",
    AGO: "前",
    MONTHS: "ヶ月",
    YEARS: "年",
    SECONDS: "秒",
    MINUTES: "分",
    HOURS: "時間",
    NOW: "今すぐ",
    DAYS: "日",
    REQUEST_EMPTY: "リクエストが空です",
    STATUS_INCORRECT: "ステータスが不正です",
    STATUS_CONTRACT_INCORRECT: "契約ステータスが不正です",
    NO_NOTIFICATION: "新しい通知はありません",
    ADDENDUM_STATUS: "付録のステータス",
    OVER_CHARACTER: "文字数を超えました",
    HOTEL_LOG_bookingCode: "予約ID",
    HOTEL_LOG_agentName: "代理店名",
    HOTEL_LOG_customer: "顧客名",
    HOTEL_LOG_createdDate: "作成日",
    HOTEL_LOG_checkinDate: "チェックイン日",
    HOTEL_LOG_checkoutDate: "チェックアウト日",
    HOTEL_LOG_totalCost: "合計費用",
    HOTEL_LOG_payableAmount: "支払額",
    HOTEL_LOG_bookingStatus: "予約ステータス",
    HOTEL_LOG_active: "アクティブ",
    HOTEL_LOG_amount: "金額/パーセント",
    HOTEL_LOG_cancellationDay: "キャンセル日",
    HOTEL_LOG_cancellationType: "キャンセルタイプ",
    HOTEL_LOG_startDate: "開始日",
    HOTEL_LOG_endDate: "終了日",
    HOTEL_LOG_hotelId: "ホテルID",
    HOTEL_LOG_type: "適用時間",
    HOTEL_LOG_notifyToEmail: "メール",
    HOTEL_LOG_notifyCCEmail: "CCメール",
    HOTEL_LOG_notifyBCCEmail: "BCCメール",
    HOTEL_LOG_includeTaxesInPrice: "価格に税金を含む",
    HOTEL_LOG_language: "言語",
    HOTEL_LOG_weekend: "週末",
    HOTEL_LOG_email: "メール",
    HOTEL_LOG_checkinAfterHour: "チェックイン後",
    HOTEL_LOG_checkoutBeforeHour: "チェックアウト前",
    HOTEL_LOG_roomServices: "ルームサービス",
    HOTEL_LOG_hotelPolicyVi: "ホテルポリシーVI",
    HOTEL_LOG_hotelPolicyEn: "ホテルポリシーEN",
    HOTEL_LOG_yearOfBuild: "建築年",
    HOTEL_LOG_numberOfFloors: "階数",
    HOTEL_LOG_numberOfRooms: "部屋数",
    HOTEL_LOG_minutesToAirport: "空港までの分数",
    HOTEL_LOG_babyAgeDetermine: "赤ちゃんの年齢の決定",
    HOTEL_LOG_childAgeDetermine: "子供の年齢の決定",
    HOTEL_LOG_electronicVoltage: "電圧",
    HOTEL_LOG_distanceToAirport: "空港までの距離",
    HOTEL_LOG_serviceTaxPercent: "サービス税率",
    HOTEL_LOG_valueAddedTaxPercent: "付加価値税率",
    HOTEL_LOG_distanceToCenter: "中心部までの距離",
    HOTEL_LOG_lat: "緯度",
    HOTEL_LOG_lng: "経度",
    HOTEL_LOG_phoneNum: "電話番号",
    HOTEL_LOG_hotLine: "ホットライン",
    HOTEL_LOG_starRanking: "星の評価",
    HOTEL_LOG_website: "ウェブサイト",
    HOTEL_LOG_addressVi: "住所 VI",
    HOTEL_LOG_addressEn: "住所 EN",
    HOTEL_LOG_hotelNameVi: "ホテル名 VI",
    HOTEL_LOG_hotelNameEn: "ホテル名 EN",
    HOTEL_LOG_hotelTypeVi: "ホテルタイプ VI",
    HOTEL_LOG_hotelTypeEn: "ホテルタイプ EN",
    HOTEL_LOG_cityVi: "都市 VI",
    HOTEL_LOG_countryVi: "国 VI",
    HOTEL_LOG_locationVi: "県 VI",
    HOTEL_LOG_cityEn: "都市 EN",
    HOTEL_LOG_areaVi: "エリア VI",
    HOTEL_LOG_countryEn: "国 EN",
    HOTEL_LOG_locationEn: "県 EN",
    HOTEL_LOG_areaEn: "エリア EN",
    HOTEL_LOG_descriptionVi: "説明 VI",
    HOTEL_LOG_descriptionEn: "説明 EN",
    HOTEL_LOG_depositType: "デポジットタイプ",
    HOTEL_LOG_cutOfDate: "デポジット締切日",
    HOTEL_LOG_paymentDay: "支払い期日",
    HOTEL_LOG_proNameVi: "プロモーション名 VI",
    HOTEL_LOG_proNameEn: "プロモーション名 EN",
    HOTEL_LOG_promoType: "タイプ",
    HOTEL_LOG_sessionType: "タイプ",
    HOTEL_LOG_discountOrSurcharge: "割引/追加料金率",
    HOTEL_LOG_coupon: "クーポン",
    HOTEL_LOG_orderType: "適用タイプ",
    HOTEL_LOG_notApplyDates: "適用外の日付",
    HOTEL_LOG_applyPlans: "適用プラン",
    HOTEL_LOG_applyAgents: "適用代理店",
    HOTEL_LOG_applyLevels: "適用レベル",
    HOTEL_LOG_applyDays: "適用日",
    HOTEL_LOG_bookType: "予約タイプ",
    HOTEL_LOG_fromDays: "から",
    HOTEL_LOG_toDays: "まで",
    HOTEL_LOG_minOrder: "最小注文",
    HOTEL_LOG_freeForMinOrder: "最小注文で無料",
    HOTEL_LOG_percentOrFixed: "割合または固定",
    HOTEL_LOG_startBook: "予約開始日",
    HOTEL_LOG_endBook: "予約終了日",
    HOTEL_LOG_objectType: "対象タイプ",
    HOTEL_LOG_delete: "削除",
    HOTEL_LOG_promotionNameVi: "プロモーション名 VI",
    HOTEL_LOG_promotionNameEn: "プロモーション名 EN",
    HOTEL_LOG_promotionDesVi: "説明 VI",
    HOTEL_LOG_promotionDesEn: "説明 EN",
    HOTEL_LOG_code: "リクエストID",
    HOTEL_LOG_note: "メモ",
    HOTEL_LOG_requestStatus: "リクエストのステータス",
    HOTEL_LOG_fullName: "氏名",
    HOTEL_LOG_gender: "性別",
    HOTEL_LOG_phoneNumber: "電話番号",
    HOTEL_LOG_position: "役職",
    HOTEL_LOG_address: "住所",
    HOTEL_LOG_maxChildren: "最大子供数",
    HOTEL_LOG_maxAdults: "最大大人数",
    HOTEL_LOG_totalRoom: "部屋総数",
    HOTEL_LOG_defaultPrice: "基本料金",
    HOTEL_LOG_weekendPrice: "週末料金",
    HOTEL_LOG_roomSize: "部屋のサイズ",
    HOTEL_LOG_numberOfExtraBeds: "エキストラベッド数",
    HOTEL_LOG_bedTypeTitleVi: "部屋名 VI",
    HOTEL_LOG_bedTypeTitleEn: "部屋名 EN",
    HOTEL_LOG_viewVi: "部屋ビュー VI",
    HOTEL_LOG_viewEn: "部屋ビュー EN",
    HOTEL_LOG_bedTypeVi: "ベッドタイプ VI",
    HOTEL_LOG_bedTypeEn: "ベッドタイプ EN",
    HOTEL_LOG_sellAllotment: "販売割当",
    HOTEL_LOG_roomName: "部屋タイプ",
    HOTEL_LOG_amenityName: "部屋の設備",
    HOTEL_LOG_id: "コード",
    HOTEL_LOG_nameVi: "名前 VI",
    HOTEL_LOG_nameEn: "名前 EN",
    HOTEL_LOG_adultsIncluded: "含まれる大人",
    HOTEL_LOG_exAdult: "追加大人料金",
    HOTEL_LOG_aexType: "大人タイプ",
    HOTEL_LOG_childrenInclued: "含まれる子供",
    HOTEL_LOG_exChild: "追加子供料金",
    HOTEL_LOG_cexType: "子供タイプ",
    HOTEL_LOG_start: "開始日",
    HOTEL_LOG_end: "終了日",
    HOTEL_LOG_sesType: "滞在時間",
    HOTEL_LOG_minStay: "最短宿泊日数",
    HOTEL_LOG_maxStay: "最長宿泊日数",
    HOTEL_LOG_extraBedPrice: "エキストラベッド料金",
    HOTEL_LOG_rooms: "部屋タイプ",
    HOTEL_LOG_meals: "食事含む",
    HOTEL_LOG_plans: "プラン名",
    HOTEL_LOG_promotions: "プロモーション名",
    HOTEL_LOG_avatar: "アバター",
    HOTEL_LOG_userName: "ユーザー名",
    HOTEL_LOG_userGroup: "ユーザーグループ",
    HOTEL_LOG_owner: "役職",
    HOTEL_LOG_name: "名前",
    HOTEL_LOG_functions: "機能コード",
    HOTEL_LOG_users: "アカウント",
    HOTEL_LOG_description: "説明",
    HOTEL_LOG_enterpriseName: "企業名",
    HOTEL_LOG_registeredAddress: "企業住所",
    HOTEL_LOG_taxCode: "税コード",
    HOTEL_LOG_bankAccountNumber: "銀行口座番号",
    HOTEL_LOG_bankAccountName: "口座名義",
    HOTEL_LOG_bankName: "銀行名",
    HOTEL_LOG_bankBranch: "支店名",
    HOTEL_LOG_representative: "代表者",
    HOTEL_LOG_signer: "署名者",
    HOTEL_LOG_area: "エリア",
    HOTEL_LOG_location: "場所",
    HOTEL_LOG_city: "都市",
    HOTEL_LOG_country: "国",
    HOTEL_LOG_hotline: "ホットライン",
    HOTEL_LOG_images: "画像名",
    HOTEL_LOG_amenities: "設備名",
    HOTEL_LOG_landmark: "ランドマーク",
    HOTEL_LOG_distance: "距離",
    HOTEL_LOG_unit: "単位",
    HOTEL_LOG_hotelChains: "ホテルチェーン",
    HOTEL_LOG_roomId: "部屋ID",
    HOTEL_LOG_views: "ビュー",
    HOTEL_LOG_agentId: "代理店ID",
    HOTEL_LOG_areas: "エリア名",
    HOTEL_LOG_level: "代理店レベル",
    HOTEL_LOG_userGroups: "ユーザーグループ名",
    HOTEL_LOG_hotelType: "ホテルタイプ",
    HOTEL_LOG_logo: "ホテルロゴ",
    HOTEL_LOG_currency: "通貨",
    HOTEL_LOG_pmsConfirm: "PMS",
    HOTEL_LOG_restriction: "制限",
    OTHER_POLICY: "その他のポリシー",
    IF_CANCELED: "予約をキャンセルした場合",
    DAYS_PRIOR_TO_ARRIVAL_DATE: "到着日の前日まで",
    OF_THE_BOOKING_VALUE_WILL_CHARGED: "予約金額の割合が請求されます",
    WILL_BE_CHARGED: "請求されます",
    WILL_BE_CHARGED_POCUP: "請求されます",
    RESERVATIONS: "予約",
    REQUIES_A_DEPOSIT: "デポジットが必要です",
    OF_THE_BOOKING_VALUE: "予約金額の割合",
    THE_REMAINING_AMOUNT: "残額は以下の期限までに支払う必要があります",
    THE_REMAINING_DAYS: "チェックイン前に残額を支払う必要があります",
    PAYMENT_WHEN_CHECKIN: "チェックイン前の支払い",
    PAYMENT_WHEN_CHECKOUT: "チェックアウト前の支払い",
    VIEWDETAIL_PHOTO: "写真をもっと見る",
    PAYMENT_100: "予約金額の100％を支払う",
    CANCEL_100: "キャンセル料100％が請求されます",
    FREE_DEPOSIT: "デポジット不要",
    ARRIVAL_DATE: "到着日",
    LEAVING_DATE: "出発日",
    CHIlDRENTS: "子供たち",
    CHIlDRENT: "子供",
    ADULTS: "大人",
    FREE_CANCEL: "キャンセル無料",
    CHARGE: "追加料金が発生します",
    CHARGE_AS_ADULTS: "大人料金として請求",
    CHILDREN_BELOW: "以下の子供",
    CHILDREN_OVER: "以上の子供",
    CHILDREN_FROM: "からの子供",
    AGES: "歳",
    DISCOUNT: "割引",
    READ_MORE: "もっと読む",
    READ_LESS: "閉じる",
    PICTURE_FACILITIES: "写真と施設",
    CAPACITY: "収容人数",
    OPTIONS: "部屋プラン",
    ALL_CAPACITY: "すべての施設を表示",
    UN_ALL_CAPACITY: "表示を減らす",
    PAYMENT_BEFORE: "事前支払い",
    NO_PAYMENT_BEFORE: "事前支払いは不要",
    BOOK_WITHIN: "以内に予約",
    PAYMENT_100_NOW: "今すぐ予約金額の100％を支払う",
    CANCEL_FREE_FROM: "からの予約キャンセル無料",
    TO_H: "最初に来る",
    CANCEL_FREE_BEFORE: "前にはキャンセル料はかかりません",
    FROM: "から",
    UNTIL: "まで",
    EARLY_CONFIRM: "早期確認！",
    SEND_REQUEST_BOOKING: "予約リクエストを送信",
    SEND_REQUEST_CART: "リクエストを追加",
    SEND_REQUEST_NOW: "今すぐリクエストを送信",
    AREA_INFO: "エリア情報",
    CANCELLATION_POLICY: "キャンセルポリシー",
    CHILD_AND_BED: "子供ポリシー",
    IF_CANCELED_BEFORE: "キャンセル前",
    THERE_ARE: "あります",
    ROOM_TYPES_WITH: "の部屋タイプ",
    OPTIONS_DETAIL: "部屋プラン",
    SPECIAL_OFFER: "特別オファー",
    HOTEL_POLICY: "ホテルポリシー",
    CHECK_AVAILABILITY: "部屋を探す",
    PRICE_FOR: "価格",
    ONLY: "のみ",
    NIGHT: "泊",
    ROOM_LEFT: "残りの部屋",
    THE_PRICE_DOES_NOT_INCLUDE_VAT: "価格には税金が含まれていません",
    SERVICE_CHARGE: "サービス料金",
    THE_PRICE_DOES_INCLUDE_VAT: "価格には税金が含まれています",
    THE_PRICE_DOES_NOT_INCLUDE_VAT_NOT_TOOL: "税金を含まない",
    SERVICE_CHARGE_NOT_TOOL: "料金",
    THE_PRICE_DOES_INCLUDE_VAT_NOT_TOOL: "税金を含む",
    ADD_ROOM: "部屋を追加",
    BOOK_NOW: "今すぐ予約",
    AND_SERVICE_CHARGE: "およびサービス料",
    AND_SERVICE_CHARGE_NOT_TOOL: "および料金",
    NO_CHARGE: "料金なし",
    ADULTS_BTN_RESULTSEARCH: "大人",
    ABOVE_12_YEARS: "12歳以上",
    CHILDRENS_BTN_RESULTSEARCH: "子供",
    BELLOW_12_YEARS: "12歳未満",
    ROOM: "部屋",
    HOW_OLD_ARE_THE_CHILDRENT: "同行する子供の年齢",
    CHECKIN: "チェックイン",
    CHECKOUT: "チェックアウト",
    T2: "月",
    T3: "火",
    T4: "水",
    T5: "木",
    T6: "金",
    T7: "土",
    T8: "日",
    TH1: "1月",
    TH10: "10月",
    TH11: "11月",
    TH12: "12月",
    TH2: "2月",
    TH3: "3月",
    TH4: "4月",
    TH5: "5月",
    TH6: "6月",
    TH7: "7月",
    TH8: "8月",
    TH9: "9月",
    MOST_POPULAR: "人気の施設",
    EVERY_OPTION: "その他の施設",
    GIFT_CODE: "割引コード",
    COPY_THIS_CODE: "このコードをコピーして支払いページに貼り付けてください",
    ENDOW: "割引",
    APPLY_FOR_MIN_ORDER_FROM: "最低注文金額から適用",
    APPLY_ON_TOTAL_ROOM_RATE: "総部屋料金に適用",
    APPLY_ON_TOTAL_BOOKING: "総予約金額に適用",
    APPLY_ON_TOTAL_SERVICE: "すべてのサービス料金に適用",
    APPLY_ALL_ORDER: "すべての注文に適用",
    NO_ROOM_LEFT: "部屋が利用できません",
    QUIT_FAVORITE: "お気に入りに追加しました",
    SUM_PROMOTION: "累積プロモーション",
    PRIORITY_PROMOTION: "優先プロモーション",
    BEST_PROMOTION: "最高のプロモーション",
    TYPE_PROMOTION: "プロモーション設定",
    INDEX: "インデックス",
    PMS_SUCCESS: "おめでとうございます。ホテルがezCrsで部屋の販売を完了しました",
    COMPLETE_INFOMATION: "情報を完成させる",
    SERVICE: {
        CONFIRM_DELETE_SERVICE: "削除してもよろしいですか？",
        CONFIRM_DEACTIVE_SERVICE: "無効化してもよろしいですか？",
        SPECIAL_PRICE: "日割り料金",
        SPECIAL_PRICE_TITLE: "日付",
        SPECIAL_PRICE_VALUE: "料金",
        ADD_SPECIAL_PRICE: "特別日料金を追加",
        HAS_EXITS: "存在します",
        LINK: "リンクリスト",
        STATUS_SYNC: "同期ステータス",
        ORDER: "順序",
        THUMBNAIL: "画像",
        STATUS: "ステータス",
        DEACTIVE: "無効",
        ACTIVE: "有効",
        SYNC_PMS: "PMSから同期",
        LIST: "サービスリスト",
        INFO: "サービス情報",
        NAME: "タイトル",
        DESCRIPTION_INFO: "説明",
        DESCRIPTION_INFO_DEFAULT: "説明",
        CODE: "サービスコード",
        TIME_APPLY: "時間設定",
        DAY_APPLY: "曜日",
        DAYS_NOT_APPLY: "除外日",
        ADD_DAYS_NOT_APPLY: "除外日を追加",
        TIME_BOOK: "予約日",
        TIME_USE: "滞在日",
        FREE: "無料サービス",
        PREMIUM: "有料サービス",
        PRICE: "料金",
        PRICE_STATUS: "サービス料金",
        INCLUDE_TAX: "税込",
        CURRENCY: "通貨",
        COPPY: "コピー",
        UNIT: "単位",
        PER_BOOKING: "予約ごと",
        PER_PERSON_PER_NIGHT: "1人1泊ごと",
        PER_ROOM: "部屋ごと",
        PER_ROOM_PER_NIGHT: "部屋1泊ごと",
        PER_PERSON: "1人ごと",
        TAX_LABEL: "税金",
        MAXBOOK: "最大注文数",
        PACKAGE_SELL: "料金プラン",
        PACKAGE_ALL: "すべて",
        PACKAGE_SPEC: "一部の料金プラン",
        SELL_CHANEL: "適用される販売チャネル",
        CHANEL_ALL: "すべての販売チャネルに適用",
        CHANEL_SPEC: "一部の特定チャネルに適用",
        CODE_MAX_LENGTH: "2文字以上でなければなりません",
        SPECIAL_DESC: "特定日料金",
        NOT_EMPTY: "空白にはできません",
        ERROR_DUPLICATE_DAY: "日付が重複しています。再確認してください",
        TAX_DEFAULT: "デフォルト",
        UPDATE_IMAGE_SUCCESS: "画像のアップロードが成功しました",
        UPDATE_IMAGE_FAIL: "画像のアップロードが失敗しました",
        CANCEL: "キャンセル",
        NOTHUMB: "画像は空欄にできません",
        IMAGE_TOO_LARGE: "画像サイズは最大8MBです",
        BINDING_PRICE: "部屋料金に含まれています",
        MAXQUATITY: "サービスの最大数",
        UNLIMIT: "無制限",
        LIMIT: "制限",
        ONE_TIME: "1回限り",
        CONFIRM_ACTIVE_SERVICE: "本当に有効にしますか？",
        BENEFIT: "特典と設備",
        MANDATORY_ADD_ON: "必須追加オプション",
        MANDATORY_ADD_ON_INFO: "選択すると、予約が行われた際にサービスが自動的に適用されます。",
    },
    IMAGE_NOT_EXIST: "写真がまだありません",
    IMAGE_SERVICE: "写真",
    _ROOM_SALE: {
        ROOM_TYPE: {
            ROOM_TYPE: "部屋タイプ",
            ROOM_CODE: "部屋コード",
            MAX_PERSON: "最大宿泊者数",
            MAX_ADULT: "最大大人数",
            MAX_CHILD: "最大子供数",
            MAX_KID: "最大幼児数",
            ROOM_PARENT_TYPE: "親部屋",
            ERROR_ROOM_CODE: "部屋コードは重複や空欄にはできません",
            ERROR_ROOM_PARENT: "選択した部屋は現在の部屋の親として設定されています"
        },
        EXPAND: "もっと表示",
        UNEXPAND: "表示を減らす",
        SELL_CHANNEL: "販売チャネル",
        SELL_MARKET: "販売市場",
        SELL_CHANNEL_ALL: "すべてのチャネル",
        SELL_CHANNEL_SPEC: "特定のチャネル",
        SELL_MARKET_ALL: "すべての市場",
        SELL_MARKET_SPEC: "特定の市場",
        LABEL_SEARCH_CODE_NAME: "コード/部屋タイプ",
        ENTER_HOTEL_NAME_OR_CODE: "コード/部屋タイプを入力",
    },
    _SALE_PACKAGE: {
        SALE_PACKAGE: "料金プラン",
        ADD_NEW: "新しい料金プランを追加",
        ENTER_SALE_PACKAGE_NAME_OR_CODE: "コード/料金プランを入力",
        RATE_CATEGORY: "料金カテゴリー",
        RATE_CATEGORY_ADD_NEW: "新しい料金カテゴリーを追加",
        ROOM_CATEGORY: "部屋カテゴリー",
        ROOM_CATEGORY_ADD_NEW: "新しい部屋カテゴリーを追加"
    },
    ADD_NEW_ROOM: "新しい部屋を追加",
    ROOMS_PER_PAGE: "1ページあたりの部屋数",
    NOT_EMPTY: "値を入力してください",
    _SERVICE_PACKAGE: {
        AGE_MAX_CHILD: "最大子供年齢",
        AGE_MAX_BABY: "最大幼児年齢",
        DAY_APPLY_IN_WEEK: "適用曜日",
        PAYMENT_POLICY: "支払いポリシー",
        CANCEL_POLICY: "キャンセルポリシー",
        APPLY_OBJECT: "対象者",
        APPLY_CARD: "カードタイプ",
        PACKAGE_CODE: "料金コード",
        ADD_PAYMENT_POLICY: "支払いポリシーを追加",
        ADD_CANCEL_POLICY: "キャンセルポリシーを追加",
        SALE_PACKAGE_CODE: "料金コード",
        ERROR_SALE_PACKAGE_CODE: "料金コードは重複や空欄にはできません",
    },
    PACKAGE_PER_PAGE: "1ページあたりのパッケージ数",
    ADD_RANGE_DAYS_NOT_APPLY: "ブラックアウト日を追加",
    NOT_APPLY_RANGE_DATE: "ブラックアウト日",
    ROOM_AVAILABLE: "在庫",
    NO_ROOM_PARENT: "なし",
    ROOM_RATE: "部屋料金",
    ADD_SALE_PACKAGE: "料金プランを追加",
    ADD_DATE_RANGE: "日付範囲を追加",
    CONFIRM_DELETE_SALE_PACKAGE_DATE_RANGE: "日付範囲の削除を確認しますか？",
    SELECT_SALE_PACKAGE: "料金プランを選択",
    LIST_SALE_PACKAGE_EMPTY: "料金プランが空です",
    VIEW_TABLE: "表として表示",
    VIEW_CALENDAR: "カレンダーとして表示",
    SELECT_ROOM_TO_VIEW: "表示する部屋を選択してください",
    SHOW_ROOM_AVAIL: "在庫数を表示",
    ROOM_CONNECTED_OTA: "OTAと同期された部屋",
    RESTRICTION_PACKAGE: "制限パッケージ",
    RESTRICTION: "制限",
    ENTER_RESTRICTION_NAME_OR_CODE: "制限名またはコードを入力",
    CONFIRM_DELETE_RESTRICTION: "制限パッケージの削除を確認しますか？",
    RESTRICTION_INFOMATION: "制限情報",
    CONFIG_RESTRICTION: "制限設定",
    DEFAULT: "デフォルト",
    ROOMTYPE: "部屋タイプ",
    ROOMPLAN: "料金プラン",
    RESTRICTION_NAME: "制限名",
    ADD_NEW_RESTRICTION: "新しい制限を追加",
    METADATA: "更新を選択",
    RESTRICTION_BULK_UPDATE: "一括更新",
    RESTRICTION_BULK_DELETE: "一括削除",
    ROOM_AVAIL: "在庫",
    SELL_LIMIT: "販売制限",
    STOP_SELL_LIMIT: "販売停止制限",
    PRICE: "料金",
    MANAGE_SYNC_OTA: "チャネル同期",
    MANAGE_ALIAS_OTA: "ezCms Vela",
    ALL_ROOM: "すべての部屋",
    NOT_SELECT_SALE_PACKGE: "料金プランを選択してください",
    DATA_INPUT_INVALID: "無効なデータ",
    UPDATE: "更新",
    SELECT_ROOM_APPLY: "部屋タイプを選択",
    SELECT_SALE_PACKAGE_APPLY: "料金プランを選択",
    SPECIAL_PRICE: "日別料金",
    ENTER_PRICE_AND_CHOSE_SALE_PACAKGE: "料金と料金プランが空です",
    minStay: "最小滞在日数",
    maxStay: "最大滞在日数",
    minStayArrival: "最小到着滞在日数",
    maxStayArrival: "最大到着滞在日数",
    minBookingWindow: "最小予約期間",
    maxBookingWindow: "最大予約期間",
    minBookingWindowByHour: "時間単位の最小予約期間",
    maxBookingWindowByHour: "時間単位の最大予約期間",
    exactStay: "正確な滞在期間",
    exactStayArrival: "正確な到着滞在期間",
    fromCheckout: "チェックアウトから",
    cutOfTime: "カットオフ時間",
    closedOnArrival: "到着時に閉鎖",
    closedOnDeparture: "出発時に閉鎖",
    closed: "販売停止",
    belongTo: "所属",
    appliedFor: "適用対象",
    CHANNEL_APPLY: "チャネル",
    CHANNEL_EMPTY: "チャネルが空です",
    APPLY_FOR: "対象",
    priceExtraAdult: "追加大人料金",
    priceExtraChild: "追加子供料金",
    priceExtraBaby: "追加幼児料金",
    DAY_SPECIAL: "日別料金",
    SUN_SHORT: "日",
    MON_SHORT: "月",
    TUE_SHORT: "火",
    WED_SHORT: "水",
    THU_SHORT: "木",
    FRI_SHORT: "金",
    SAT_SHORT: "土",
    JAN_SHORT: "1月",
    FEB_SHORT: "2月",
    MAR_SHORT: "3月",
    APR_SHORT: "4月",
    MAY_SHORT: "5月",
    JUN_SHORT: "6月",
    JUL_SHORT: "7月",
    AUG_SHORT: "8月",
    SEP_SHORT: "9月",
    OCT_SHORT: "10月",
    NOV_SHORT: "11月",
    DEC_SHORT: "12月",
    NO_SELECT: "変更なし",
    OPEN: "開く",
    CONFIRM_DELETE_SPECIAL_PRICE: "日別料金の削除を確認",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_ADULT: "日別追加大人料金の削除を確認",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_CHILD: "日別追加子供料金の削除を確認",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_BABY: "日別追加幼児料金の削除を確認",
    REMOVE_SPECIAL_PRICE: "日別料金を削除",
    NO_DATA: "データがありません",
    CURRENCY_OTA: "チャネルの通貨",
    ROOM_TYPE_ON_OTA: "OTA上の部屋タイプ",
    SALE_PACKAGE_ON_OTA: "OTA上の料金プラン",
    NUMBER_OF_PERSON: "人数",
    PACKAGE_TYPE: "パッケージタイプ",
    RATES: "料金",
    RATES_OSCILLATE: "追加料金",
    REGULAR_PRICE: "通常料金",
    SYNCED: "同期済み",
    ROOM_CLOSED: "閉鎖",
    NO_SALEPACKAGE_AVAIL: "利用可能な料金プランなし",
    YES: "はい",
    NO: "いいえ",
    BOOKING_CUSTOMER_NAME: "顧客名",
    BOOKING_EMPTY: "予約が見つかりません。",
    BOOKING_CHANNEL: "チャネル",
    BOOKING_HOTEL: "ホテル",
    STT: "番号",
    BOOKING_IS_NOT_EXIST: "予約が存在しません",
    ADD_NEW_SALE_CHANNEL: "新しいチャネルを追加",
    CONNECT: "接続",
    SELECT_SALE_CHANNEL: "チャネルを選択",
    PHONE_INVALID: "無効な電話番号",
    EMAIL_INVALID: "無効なメールアドレス",
    LOGIN_NOW: "今すぐログイン！",
    POLICY_NAME: "ポリシー名",
    POLICY_DESCRIPTION: "ポリシー説明",
    DESCRIPTION: "説明",
    APPLY_DAY: "適用日",
    DEPOSIT_UNIT: "単位",
    APPLY_FOR_STAYING: "滞在日による",
    APPLY_FOR_BOOKING: "予約日による",
    CHECKOUT_DATE: "チェックアウト日",
    CHECKIN_DATE: "チェックイン日",
    BEFORE_CHECKIN_DATE: "チェックイン日の前",
    BEFORE_CHECKOUT_DATE: "チェックアウト日の前",
    CANCEL_ROOM_IN_ROUND_X_DAY_BEFORE: "x日前までキャンセル可",
    NIGHT_CAP: "0泊 | 1泊 | {count}泊",
    CHANGE_PASSWORD_REQUEST_NO_LONGER_WORK: "パスワード変更リクエストが無効になりました！",
    MAXROOM_1000: "最大部屋数は1000",
    DATA_INPUT_MAX_100_PERCENT: "最大値100",
    DATA_INPUT_MAX_10_NIGHT: "最大値10泊",
    DUPLICATE_CODE: "コードが重複しています",
    CREATE: "作成",
    BULK_UPDATE: "一括更新",
    SETUP_OTA: "OTA設定",
    AUTH: "ホテルアクセス",
    RECEIVE_BOOKING_FROM_OTA: "OTAからの予約受信",
    UPDATE_INVENTORY: "PMSから在庫更新",
    RECEIVE_INVENTORY_UPDATE_FROM_PMS: "PMSからOTAへの在庫更新を受信",
    PUSH_BOOKING_NOTIFICATION_TO_PMS: "PMSに予約通知を送信",
    HOTEL_INFO: "ホテル情報",
    HOTEL_IMAGE: "ホテル画像",
    HOTEL_AREA: "ホテルエリア",
    HOTEL_AMENITY: "ホテル設備",
    HOTEL_CANCELLATION_POLICY: "ホテルキャンセルポリシー",
    HOTEL_SETTING: "ホテル設定",
    HOTEL_PAYMENT_POLICY: "ホテル支払いポリシー",
    SETUP_AND_MAPPING_TO_OTA: "OTAへの設定とマッピング",
    HOTEL_RATE_PLAN: "ホテル料金プラン",
    HOTEL_RESTRICTION: "ホテル制限",
    HOTEL_ROOM_TYPE: "ホテル部屋タイプ",
    HOTEL_ROOM_TYPE_AMENITY: "部屋タイプ設備",
    HOTEL_ROOM_TYPE_AVAILABILITY: "部屋タイプの在庫",
    HOTEL_ROOM_RATE: "部屋料金",
    HOTEL_ROOM_TYPE_STOP_SELL: "部屋タイプ販売停止",
    HOTEL_ROOM_RATE_ADULT: "大人の部屋料金",
    HOTEL_ROOM_RATE_CHILD: "子供の部屋料金",
    HOTEL_ROOM_RATE_BABY: "幼児の部屋料金",
    HOTEL_ROOM_RATE_SPECIAL: "特別部屋料金",
    STAFF_INFO: "スタッフ情報",
    STAFF_PASSWORD: "スタッフパスワード",
    STAFF_AVATAR: "スタッフアバター",
    STAFF_LOGIN: "スタッフログイン",
    HOTEL_REGISTER: "ホテル登録",
    CHANGE_STATUS: "ステータス変更",
    LOG_ACTION: "アクション",
    LOG_FUNCTION: "機能",
    LOG_CONTENT: "ログ",
    LOG_DATE_CREATE: "作成日",
    LOG_USERNAME: "ユーザー名",
    PRICE_ON_OTA: "OTA上の料金",
    PRICE_ON_DEFINED: "宣言された料金",
    STOP_SELL_TRIGGER: "販売停止トリガー",
    DOWNLOAD: "ダウンロード",
    CONFIRM_CHANGE_STATUS_SALE_PACKAGE: "料金プランがOTAと同期されています。ステータスを変更してもよろしいですか？",
    CONFIRM_CHANGE_STATUS_ROOMTYPE: "部屋タイプがOTAと同期されています。ステータスを変更してもよろしいですか？",
    hotel_id: "ホテルID",
    property_id: "物件ID",
    HOTEL_ROOM_TYPE_IMAGES: "部屋画像",
    IMAGE_MANAGAMENT: "ギャラリー",
    UNIT: "単位",
    NEARBY_TYPE: "近くのタイプ",
    DIALOG_CONFIRM_DESC: "料金プランの設定に基づいて制限付き更新しますか？",
    CANNOT_GET_INFO_FROM_OTA_1: "OTAとの通信が中断されています。",
    CANNOT_GET_INFO_FROM_OTA_2: "1900 9013に連絡するか、メールでhotro@ezcloud.vnにご連絡ください。",
    ROOMTYPE_HAS_NO_RATEPLAN: "事前に設定された部屋タイプ、料金プラン、チャネルの組み合わせを入力してください。",
    MAX_LENGTH_10: "データの最大長は10文字です",
    UPDATE_BY: "更新者",
    OTA_HAS_NO_RATEPLAN: "このOTAにはまだパッケージがありません",
    PRICE_IS_REQUIRED: "料金が未入力です",
    HOTEL_ROOM_IS_OVER_LIMIT: "ホテルの部屋が制限を超えています",
    CONFIRM_DELETE_PROMOTION: "プロモーションを削除してもよろしいですか？",
    ADD_NEW_PROMOTION: "新しいプロモーションを追加",
    ADD_NEW_SERVICE: "新しいサービスを追加",
    PRICE_EXTRA: "追加料金",
    PERSON_NUMBER: "人数",
    DETAIL: "詳細",
    PRICE_AND_PERSON_IS_REQUIRED: "料金と人数が必須です",
    CHOOSE_LANG_PAYMENT: "支払い方法の言語を選択",
    ENTER_CONTENT_SHOW: "表示する内容を入力",
    CONFIG_BE: "予約エンジン",
    SAVE_SUCCESS: "保存成功",
    CONFIGURE_OUGING_EMAIL: "送信メール設定",
    EMAIL_SEND: "メールアドレス",
    EMAIL_NAME_SEND: "表示名",
    SERVER_MAIL_ADDRESS: "SMTPサーバー",
    CONNECTOR: "SMTPポート",
    ENCRYPTION_TYPE: "セキュア接続",
    AUTHENTICATON_CONNECTION: "認証接続",
    EMAIL_TYPE: "メールタイプ",
    TEST_EMAIL_SENT: "テストメール送信",
    SENT_EMAIL_TEST: "テストメールを送信",
    EMAIL_SETTING_EXISTED: "メール設定が既に存在します",
    ERROR_MAIL: "エラー",
    SUCCESS_MAIL: "メール送信成功",
    UNIT_ROOM_PRICE: "部屋料金単位",
    FROM_CHECKOUT: "チェックアウトから",
    NON_REFUNDABLE: "返金不可",
    GUEST_NAME: "ゲスト名",
    FROM_TIME: "開始時間",
    TO_TIME: "終了時間",
    PROMOTION_CODE: "プロモーションコード",
    SORT: "並べ替え",
    HAS_CONNECTED: "接続済み",
    GUEST: "ゲスト",
    COUPON_CODE: "クーポンコード",
    PAYMENT_REQUIRED_UPON_BOOKING: "予約時に支払いが必要",
    CONDITIONS: "条件",
    HOW_MUCH_PAYMENT_IS_MADE_BY_THE_GUEST_ON_THE_DAY_OF_BOOKING: "予約日にゲストが支払った金額は？",
    PERCENT_OF_TOTAL_ROOM_RATE: "部屋料金の割合",
    WHEN_DOES_THE_CUSTOMER_MAKE_THE_PAYMENT_FOR_THE_REMAINING_AMOUNT: "残金の支払いタイミングは？",
    WHAT_THE_PAYMENT_POLICY_FOR_THE_BOOKING_PERIOD: "予約期間の支払いポリシーは？",
    WHAT_DOES_PAYMENT_POLICY_APPLY: "支払いポリシーの適用期間は？",
    POLICY_SUMMARY: "ポリシー概要",
    PERCENT_BOOKING: "予約率",
    WHEN_DOES_THE_CUSTOMER_MAKE_THE_PAYMENT: "支払いのタイミングは？",
    DATA_INPUT_MAX_24_HOUR: "データは24時間以内でなければなりません",
    DAY: "日",
    HOUR: "時間",
    HOW_MUCH_DOES_THE_CUSTOMER_MAKE_PAYMENT: "支払金額は？",
    ON_THE_DAY_OF_CHECK_IN: "チェックイン日",
    ON_THE_DAY_OF_CHECK_OUT: "チェックアウト日",
    PRICE_PER_NIGHT: "1泊料金",
    ON_THE_DATE_OF_BOOKING: "予約日",
    UPDATE_PRICE_NOTE: "料金と数量データは上書きされます。マスタールーム料金の更新は子部屋料金に影響します。",
    PROMOTION_TITLE: "プロモーションタイトル",
    FREE_CANCELLATION_ALLOWED: "無料キャンセル許可",
    HOW_LONG_BEFORE_CHECK_IN_CAN_GUESTS_CANCEL_FOR_FREE: "チェックイン前何日まで無料キャンセルできますか？",
    DAY_BEFORE_CHECK_IN: "チェックイン前{day}日",
    ACCORDING_TO_CUSTOM: "カスタマイズ済み",
    HOW_MUCH_DO_GUESTS_HAVE_TO_PAY_WHEN_THEY_CANCEL_A_RERVATION_DAYS_PRIOR_TO_ARRIVAL: "到着前{day}日にキャンセルした場合の支払額は？",
    HOW_MUCH_DO_GUESTS_HAVE_TO_PAY_WHEN_CANCELING_A_RESERVATION: "予約をキャンセルした場合の支払額は？",
    WHAT_THE_CANCEL_POLICY_FOR_THE_BOOKING_PERIOD: "予約期間のキャンセルポリシーは？",
    WHAT_DOES_CANCEL_POLICY_APPLY: "キャンセルポリシーが適用される期間は？",
    HOW_MUCH_WILL_THE_CUSTOMER_HAVE_TOT_PAY_IF_THE_GUEST_CANCELS_ON_THE_CHECKIN: "チェックイン日にキャンセルした場合の支払額は？",
    UTC: "タイムゾーン",
    ROOM_ARE_AVAILABLE_FROM_LESS_TO_MORE: "部屋は少ない順から多い順で利用可能",
    TIME_ZONE_HOTEL: "ホテルタイムゾーン",
    BED_TYPE_SETTING: "ベッドタイプ設定",
    ROOM_TYPE_SETTING: "部屋タイプ設定",
    OVER_MAX_GUEST: "最大ゲスト数を超過しました",
    OVER_MAX_ADULTS: "大人の最大数を超えました",
    OVER_MAX_CHILDREN: "子供の最大数を超えました",
    OVER_MAX_BABY: "幼児の最大数を超えました",
    UNDER_MAX_ADULTS: "料金パッケージの大人の最大数を満たしていません",
    UNDER_MAX_CHILDREN: "料金パッケージの子供の最大数を満たしていません",
    UNDER_MAX_BABY: "料金パッケージの幼児の最大数を満たしていません",
    UNDER_MAX_QUANTITY: "部屋数が宣言された在庫を超えています",
    BOOKING_ENGINE: "予約エンジン",
    TEXT_NOTIFY_EXPIRED: "{channel}チャンネルとの接続が{date}に期限切れとなりました。OTAチャンネルへのデータ同期が停止しますので、更新してください。",
    TEXT_NOTIFY_WILL_EXPIRE: "{channel}チャンネルとの接続が{date}に期限切れとなります。OTAチャンネルへのデータ同期が停止しますので、更新してください。",
    ROOM_AND_PACKAGES_FOR_SALE_ON_GOOOGLE: "Googleホテルチャネルで販売されている部屋とパッケージ",
    HOTEL_LOG_roomTypeI18n: "部屋タイプ",
    HOTEL_LOG_lang: "言語",
    HOTEL_LOG_ratePlanI18n: "部屋パッケージ",
    HOTEL_LOG_otaI18n: "OTA",
    BE_CONNECT_REQUIRED: "予約エンジン接続が未設定",
    ACCESS_DENIED: "アクセス権限がありません",
    OTA_NOT_FOUND: "OTAが見つかりません",
    HOTEL_SYNC: "ホテルは同期されています",
    PASSWORD_SENT_SUCCESS: "パスワードが正常に送信されました",
    CAN_NOT_DELETE: "部屋タイプ/料金プランがOTAに接続されています",
    BOOKING_NOT_CANCEL: "予約のキャンセルはできません",
    HEADER_FOOTER_CONFIG: "テンプレート",
    MENU_EDIT: "メニュータイプ",
    MENU_NAME: "名前",
    MENU_CONFIG: "メニュー表示",
    WIDGETS_EDIT: "ウィジェットタイプ",
    ADD_NEW_WIDGETS: "新しいウィジェットを追加",
    WIDGETS_NOT_YET_DISPLAYED: "ウィジェットがまだ表示されていません",
    PARAMETERS: "その他の設定",
    LOGO_DISPLAYS: "ロゴURL",
    TOP_HEADER_BACKGROUND: "ヘッダートップ - 背景色",
    HEADER_BACKGROUND: "ヘッダー - 背景色",
    TEXT_HEADER_COLOR: "ヘッダー - 文字色",
    TEXT_HEADER_COLOR_ACTIVE: "メインカラー",
    FOOTER_BACKGROUND: "フッター - 背景色",
    TEXT_FOOTER_COLOR: "フッター - 文字色",
    BACKGROUND_COPYRIGHT: "フッターボトム - 背景色",
    ADD_NEW_MENU: "新しいメニューを追加",
    CONTENT_WIDGETS: "コンテンツ",
    TITLE: "タイトル",
    REFERENCE_SAMPLE: "参照サンプル",
    VI: "ベトナム語",
    EN: "英語",
    BIGGER_THAN_EQUAL: "以上",
    AND_MORE: "他{count}件",
    ALL_AGENT: "すべてのエージェント",
    GROUP_AGENT: "エージェントグループ",
    SPECIFIC_AGENT: "特定のエージェント",
    CHOOSE_NOT_APPLY_AGENT: "プロモーションが適用されないエージェントを選択",
    CHOOSE_APPLY_AGENT: "プロモーションが適用されるエージェントを選択",
    LIST_NOT_APPLY_AGENT: "プロモーションが適用されないエージェントリスト",
    LIST_APPLY_AGENT: "プロモーションが適用されるエージェントリスト",
    SEARCH_NAME_AGENT: "名前またはエージェントコードを入力",
    AGENT_TYPE: "タイプ",
    ENTERPRISE_AGENT: "企業旅行",
    ENTERPRISE_TRADING: "企業取引",
    ENTERPRISE_API: "企業API",
    LIST_AGENT: "旅行エージェントリスト",
    SUCCESS: "成功",
    CONFIG_CONNECT: "接続設定",
    NO_RECORDS: "表示するレコードがありません",
    QUANTITY: "数量",
    ROOM_PRICE: "部屋料金",
    EXTRA_ADULT: "追加大人",
    EXTRA_CHILD: "追加子供",
    HOTEL_PROMOTION: "ホテルプロモーション",
    GUEST_INFO: "ゲスト情報",
    MAX_GUEST: "ゲスト数",
    MAX: "最大",
    BOOKING_INFO: "一般情報",
    WRONG_DOMAIN: "無効なドメイン名",
    FILE_NULL: "ファイルアップロードエラー",
    PLEASE_COMPLETE_THE_FIELDS_MARKED: "必須項目をすべて入力してください",
    ADD_NEW_SOCIAL_NETWORK: "新しいソーシャルネットワークを追加",
    PRIMARY_TEXT_COLOR: "プライマリテキスト色",
    PRIMARY_BACKGROUND_COLOR: "プライマリ背景色",
    TOP_HEADER_TEXT_COLOR: "トップヘッダーテキスト色",
    TOP_HEADER_BACKGROUND_COLOR: "トップヘッダー背景色",
    HEADER_TEXT_COLOR: "ヘッダーテキスト色",
    HEADER_BACKGROUND_COLOR: "ヘッダー背景色",
    FOOTER_TEXT_COLOR: "フッターテキスト色",
    FOOTER_BACKGROUND_COLOR: "フッター背景色",
    BOTTOM_FOOTER_TEXT_COLOR: "ボトムフッターテキスト色",
    BOTTOM_FOOTER_BACKGROUND_COLOR: "ボトムフッター背景色",
    BUTTON_TEXT_COLOR: "ボタンテキスト色",
    BUTTON_BACKGROUND_COLOR: "ボタン背景色",
    BUTTON_TEXT_COLOR_2: "ボタンテキスト色2",
    BUTTON_BACKGROUND_COLOR_2: "ボタン背景色2",
    CUSTOM: "カスタム",
    URL: "リンク",
    OTA_IS_OUT_OF_TIME: "OTAチャネルがまだ有効化されていません",
    DATA_INPUT_MUST_BE_GREATER_THAN_0: "入力データは0より大きくなければなりません",
    HOTEL_EXTRA_RATE_UPDATE: "追加料金を更新",
    HOTEL_EXTRA_RATE_DELETE: "追加料金を削除",
    DATE_OF_STAY_DOES_NOT_APPLY: "宿泊日は適用されません",
    DATE_OF_BOOKING_DOES_NOT_APPLY: "予約日は適用されません",
    BOOKING_CODE_OTA: "OTA予約コード",
    HOTEL_WAS_CONNECTED_WITH_OTA: "ホテルはすでにOTAチャネルに接続されています",
    ROOM_TYPE_OTA: "ezCms Leo",
    CONNECTED: "接続済み",
    NOT_CONNECTED: "未接続",
    MISSING_ROOM_AND_PRICE: "部屋、料金、制限が見つかりません",
    CONNECTED_OTA: "OTAマッピング",
    SYNC_IN_PROGRESS: "同期中",
    CONNECTING: "接続中",
    ROOM_AND_PRICE_PACKAGES_HAVE_NOT_BEEN_DECLARED: "部屋パッケージと料金がまだ宣言されていません",
    CONNECTION_FAILED: "接続に失敗しました",
    SU_CONNECTION: "販売チャネル",
    SU_MAPPING: "マッピング",
    CHANNEL_MANAGER_SYSTEM: "中央予約システム",
    ENTER_NAME_OR_CODE: "コードまたは名前を入力",
    OTA_LOG: "同期ログ",
    INVENTORY_LOG: "在庫ログ",
    ERROR_LOG: "エラーログ",
    SOURCE: "ソース",
    UPDATE_TIME: "更新時間",
    RATE: "料金",
    STOP_SELL: "販売停止",
    MIN_STAY: "最短宿泊日数",
    MAX_STAY: "最長宿泊日数",
    EXTRA_ADULT_RATE: "大人追加料金",
    EXTRA_CHILD_RATE: "子供追加料金",
    FULL_UPDATE: "詳細",
    UN_STOP_SELL: "販売停止を解除",
    OPEN_RESERVATION: "予約を開く",
    OPEN_CHECKOUT: "チェックアウトを開く",
    ERROR_PHONE_NUMBER_LENGTH: "電話番号は6〜10文字でなければなりません",
    ERROR_PHONE_NUMBER_STRING: "電話番号には文字や0で始まる数字は含めないでください",
    FAILURE: "失敗",
    ACTIVE_LOG: "アクティビティログ",
    WAITING: "進行中",
    ROOM_SALE_UPDATE: "販売部屋を更新",
    PRICE_EXTRA_SPECIAL: "日別追加料金",
    BASE_PRICE_IS_MISSING: "基本料金が未設定",
    TOOLTIP_MASTER: "基準として使用する1つのマスター商品を選択",
    RULE_CODE: "英数字のみを含む2〜20文字のコード",
    ROOM_DERIVE: "派生部屋 - 親部屋タイプから派生",
    DERIVE_OF_ROOM: "派生元",
    COPY_BY_FOMULAR: "数式でコピー",
    PASTE: "貼り付け",
    DATE_RANGE: "日数範囲",
    CODE_IS_EXISTED: "サービスコードはすでに存在します",
    HOTEL_CHANGE_SUCCESS: "ホテルの変更に成功",
    ROOM_CLASS: "部屋タイプ",
    UPDATE_FOR: "{date}用に更新",
    UPDATE_RATE_BY_RANGE: "一括更新",
    BOOKER: "予約者名",
    SEARCH_BY_BOOKER: "ゲスト名",
    CONTACT_US: "お問い合わせ",
    UPDATE_TO_STOP_SELLING_OPENING: "販売停止/開始の更新",
    UPDATE_ROOM_AVAILABILITY_IN_STAGES: "一括更新",
    UPDATE_SELLING_PRICES_IN_STAGES: "料金を更新",
    UPDATE_STOP_SELL: "販売停止を更新",
    UPDATE_SELL_LIMIT_BY_OTA: "販売制限を更新",
    UPDATE_SELL_LIMIT_FOR_NEW_OTA: "新しいOTAの販売制限を更新",
    UPDATE_RESTRICTION_STOPSELL: "販売停止の更新",
    UPDATE_STOP_SELL_BY_OTA: "OTAによる販売停止の更新",
    DELETE_SELL_LIMIT_BY_OTA: "OTAによる販売制限の削除",
    DELETE_STOP_SELL_BY_OTA: "OTAによる販売停止の削除",
    OTHER_FUNCTION: "その他",
    VIEW_MOBILE_VERSION: "モバイルバージョンを表示",
    VIEW_DESKTOP_VERSION: "デスクトップバージョンを表示",
    FILTER_RESULTS: "フィルタ",
    STOPSELL_UPDATE_SUCCESS: "販売停止の更新に成功",
    REMOVE_STOPSELL_SUCCESS: "販売停止の解除に成功",
    HOTEL: "0 ホテル | 1 ホテル | {count} ホテル",
    NIGHT_NUMBER: "宿泊数",
    CONFIRM_STOP_SELL: "販売停止を更新",
    CONFIRM_REMOVE_STOP_SELL: "販売停止の解除を適用",
    APP: "アプリ",
    ENTER_THE_NAME_OF_THE_APP_WANT_TO_SEARCH_FOR: "検索したいアプリ名を入力",
    LABEL_NIGHT_BACKGROUND_COLOR: "サブ背景色1",
    LABEL_NIGHT_TEXT_COLOR: "サブスクリプトカラー1",
    PACKAGE_TEXT_COLOR: "販売パッケージテキストカラー",
    PROMOTION_BACKGROUND_COLOR: "セカンダリ背景色2",
    PROMOTION_TEXT_COLOR: "セカンダリテキストカラー2",
    PRICE_TEXT_COLOR: "価格色1",
    RANK_STAR_COLOR: "星色",
    TEXT_PRICE_2_COLOR: "コストカラー2",
    SUB_TEXT_3_COLOR: "追加テキストカラー3",
    SUB_BACKGROUND_3_COLOR: "サブ背景色3",
    RE_SYNC: "予約を再投稿",
    CONFIRM_RE_SYNC: "再投稿を確認",
    HOTEL_REPORT_BOOKING: "予約を再投稿",
    UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR: "更新間隔は1年を超えてはなりません",
    ACCOUNT_IS_NOT_CONNECTED_TO_GDS: "アカウントがezCms GDSに接続されていません",
    DISCONNECT: "切断",
    CONFIRM_DISCONNECT_OTA: "本当に切断しますか",
    CONFIRM_CONNECT_OTA: "本当に再接続しますか",
    GDS_OTA: "ezCms GDS",
    ROOM_DUPLICATE: "部屋コードは重複できません",
    ROOM_PLAN_DUPLICATE: "料金コードは重複できません",
    YOU_DONT_HAVE_ANY_HOTELS_YET: "ホテルが見つかりません。",
    TEXT_GDS_INFOMATION: "GDSは、ホテル予約のために450,000以上のTAが使用する世界規模の予約ネットワークです。",
    ROOM_TYPE_ON_CMS: "ezCrsの部屋タイプ",
    ROOM_TYPE_ON_SABRE: "販売チャネルの部屋タイプ",
    ROOM_PLAN_ON_CMS: "ezCrsの料金プラン",
    ROOM_PLAN_ON_SABRE: "販売チャネルの料金プラン",
    CHAIN_CODE: "ホテルチェーンコード",
    CHAIN_TYPE: "ホテルチェーンタイプ",
    ITEMS_SHOWING: "表示アイテム",
    TA_NAME: "代理店名",
    TA_CODE: "代理店コード",
    CHAIN_TRAVEL_AGENT_INFOMATION: "代理店情報",
    ASSIGN_TA_TO_HOTEL: "旅行代理店をホテルに割り当て",
    ALLOW_OVERWRITING_INFOMATION_DOWN_TO_THE_HOTEL: "情報をホテルに上書きすることを許可",
    FIRST_NAME: "名",
    LAST_NAME: "姓",
    CHAIN_AGENT_LIST: "会社と代理店",
    ASSIGN_ROOM_TO_HOTEL: "部屋をホテルに割り当て",
    ASSIGN_RATE_PLAN_TO_HOTEL: "料金プランをホテルに割り当て",
    CHAIN: "チェーン",
    UNASSIGN: "未割り当て",
    ASSIGN: "割り当て済み",
    CONFIRM_CHANGE_ACTIVE: "代理店ステータス変更を確認",
    ENTERPRISE_CODE: "企業コード",
    FIRST_NAME_REPRESENT: "代表者姓",
    LAST_NAME_REPRESENT: "代表者名",
    ACCOUNT_HOLDER: "アカウント保有者",
    POSITION: "職位",
    HOTEL_LIST: "ホテルリスト",
    CHAIN_CONFIG: "チェーン設定",
    ASSIGN_SERVICE_TO_HOTEL: "サービスをホテルに割り当て",
    ROOM_TYPE_CODE_HAS_SYNCED_TO_OTA: "ホテル部屋クラスが同期されました。再確認してください",
    ROOM_CODE_DUPLICATION_ROOM_CODE_IN_CHAIN: "部屋タイプコードがチェーン部屋タイプコードと一致します。再確認してください",
    ROOM_CODE_DUPLICATION: "部屋タイプコードはすでに存在します",
    CHAIN_ROOM_TYPE_IS_OVER_LIMIT: "部屋数がホテルレベルの総部屋数を超えています",
    RATE_PLAN_CODE_DUPLICATION: "販売パッケージがすでに存在します。再確認してください",
    SERVICE_NOT_EXIST: "サービスが存在しません",
    SERVICE_CODE_DUPLICATION: "サービスコードがチェーンホテルにすでに存在します。再確認してください",
    TRAVEL_AGENT_ALREADY_EXIST: "会社情報、代理店がすでに存在します。再確認してください",
    HOTEL_NOT_USE_EQUAL_CURRENCY: "割り当てられたホテルは異なる通貨を使用しています。再確認してください",
    AUTO_CANCEL: "予約が確認されていない場合、自動キャンセルを許可",
    ACCOUNT_IS_NOT_CONNECTED_TO_SITEMINDER: "アカウントがezCms SiteMinderに接続されていません",
    ACCOUNT_IS_NOT_CONNECTED_TO_TRAVELOKA: "アカウントがezCms Travelokaに接続されていません",
    ROOM_TYPE_MAP_UNMAP: "現在接続されている部屋タイプは、選択解除して保存すると切断されます。この操作は接続喪失、オーバーブッキング、マッピング解除を引き起こす可能性があります。",
    OTA_HOTEL_CODE_ALREADY_EXITS: "入力したホテルコードはすでに接続されています。再確認してください！",
    ADD_SERVICE_TO_ROOM_RATE: "販売プランにサービスを追加",
    CONFIRM_DELETE_SERVICE_PACKAGE: "このサービスを部屋料金から削除することを確認",
    PACKAGE_DEAL: "パッケージ契約",
    PACKAGE_ITEM: "パッケージアイテム",
    PRICE_ALLOCATION: "価格配分",
    WEEKLY_PRICE: "週間料金",
    DAILY_PRICE: "日次料金",
    RD_DAY: "{day}日目",
    TOTAL_PACKAGE_VALUE: "パッケージの総額",
    LIST_EDIT_SUCCESS: "更新成功",
    INFOMATION_OF_BANK_ACCOUNT: "銀行口座情報",
    CHILD_HAS_MORE_OTA_THAN_MASTER: "関係を作成できません",
    ENTIRE_HOTEL: "ホテルレベル",
    ACCORDING_TO_EACH_ROOM_CLASS: "部屋タイプレベル",
    NUMBER_OF_ROOMS_AVAILABLE: "利用可能な部屋数",
    ROOM_OCCUPANCY: "部屋稼働率",
    EDIT_DYNAMIC_PRICING: "動的価格テンプレート詳細",
    ADD_NEW_DYNAMIC_PRICING: "新しい動的価格モデルを追加",
    DYNAMIC_PRICING: "動的料金",
    CONFIRM_DELETE_DYNAMIC_PRICING: "動的料金パターンの削除を確認",
    DYNAMIC_NAME: "動的価格モデル名",
    DYNAMIC_DESCRIPTION: "動的料金パターンの説明",
    CRITERIA: "基準",
    PRICE_CALCULATION_FORMULA: "価格計算式",
    TOTAL_NUMBER_OF_ROOMS_BY_ROOM_CLASS: "部屋タイプごとの販売済部屋数（利用日予約を含む）",
    TOTAL_NUMBER_OF_ROOMS_BY_HOTEL: "ホテル全体の販売済部屋数（デイユース予約を含む）",
    TOTAL_NUMBER_OF_AVAILABLE_ROOMS_BY_ROOM_CLASS: "部屋タイプごとの利用可能部屋数",
    TOTAL_NUMBER_OF_AVAILABLE_ROOMS_BY_HOTEL: "ホテル全体の利用可能部屋数",
    ROOM_CAPACCITY_FORMULA: "部屋容量の計算式",
    FROM_TO_LESS: "{val}から未満まで",
    NO_PRIOTITY: "優先順位なし",
    PRIOTITY: "優先順位",
    UN_SELECT_ALL: "削除",
    SET_THE_PRICE_CYCLE: "動的販売",
    EVENT: "イベント別",
    CALENDAR: "スケジュール (近日公開)",
    DYNAMIC_RATE_METHOD: "動的料金方法",
    CONFIRM_DEACTIVE_DYNAMIC_RATE: "動的料金を無効化することを確認",
    RMS_MANAGEMENT: "収益管理",
    DERIVED_ROOMTYPE: "派生部屋タイプ",
    BASE: "基礎部屋タイプ",
    UPDATE_FORMULAR: "計算式を更新",
    FORMULAR: "計算式",
    SET_UP_FORMULAR_BY_DATE_RANGE: "日付範囲ごとに計算式を設定",
    MASTER_RATE: "マスター料金",
    SET_UP_FORMULAR: "計算式を設定",
    CONFIRM_DELETE_FORMULA: "計算式の削除を確認",
    EDIT_PRICE: "価格を編集",
    FOR_EXAMPLE_SERVICE: "10月1日から10月10日までの予約（9泊）<br>カスタム設定:<br><ul><li>1泊目: 1</li><li>最終泊: 最終日</li><li>サイクル使用: 2日（1回）</li><li>繰り返し回数: 3回</li></ul>サービスは10月1日から10月10日まで適用されます。<br>使用サイクルが2日ごとであるため、サービスは10月1日、3日、5日に適用されます。<br>ただし、繰り返し回数が3回であるため、サービスが適用される日は<strong>1日、3日、5日</strong>です。",
    SCHEDULINGTYPE_1: "滞在初日のみ適用",
    SCHEDULINGTYPE_2: "滞在最終日のみ適用",
    SCHEDULINGTYPE_3: "X泊ごとに1回適用、Y泊目から開始",
    SCHEDULINGTYPE_4: "初日を除くすべての夜に適用",
    SCHEDULINGTYPE_5: "最終日を除くすべての夜に適用",
    SCHEDULINGTYPE_6: "初日と最終日は適用外",
    SCHEDULINGTYPE_7: "夜（14泊）に適用",
    SCHEDULINGTYPE_8: "任意のX泊に適用",
    SCHEDULINGTYPE_9: "カスタム",
    SCHEDULINGTYPE_0: "すべての夜",
    EXAMPLE: "例",
    STARTING_FROMM_NIGHT: "開始泊",
    ENDS_ON_NIGHT: "終了泊",
    USE_CYCLE: "使用サイクル",
    NUMBER_OF_REPETITION: "繰り返し回数",
    NUMBER_OF_REPETITION_DETAIL: "サイクル使用（X泊ごとに1回適用）",
    NIGHT_14_DESCRIPTION: "14泊以上の予約では、14泊後に選択サイクルに従って再度適用",
    CODE_NOT_EMPTY: "コードは重複または空白にできません",
    BEFORE_THE_LAST_NIGHT: "最終夜の前",
    LAST_NIGHT: "最終夜",
    CONFIRM_UPDATE_PRICE_SERVICE_GREATER_THAN_TOTAL_PACKAGE: "配分価格がパッケージ価格を超えています。更新を確認しますか？",
    EDIT_ATTRIBUTION: "割り当てを編集",
    MIN_ROOM_RATE: "最低部屋料金",
    SETUP_FORMULA: "計算式を更新",
    SETUP_FORMULA_BY_DATE_RANGE: "日付範囲ごとに計算式を更新",
    DELETE_FORMULA: "計算式を削除",
    CAN_NOT_CREATE: "親部屋販売に依存しているため、部屋販売を作成できません",
    HAVE_BEEN_CONNECTED_TO_OTA: "部屋クラス/パッケージがOTAに接続されています",
    CAN_NOT_INACTIVE_OR_DELETE: "更新できません",
    ROOM_RATE_IS_CHILDREN: "更新中の製品は派生製品です",
    TO_LESS: "未満",
    COMBO: "パッケージ",
    TITLE_DESCRIPTION_DYNAMIC_CHANGE: "イベントによる変更方法では、ホテルが在庫に関連する動的料金/制限をイベントごとに設定できるようにします。含まれる要素は以下の通りです：",
    CHANGE_TYPE_1: "PMSから在庫が更新された",
    CHANGE_TYPE_2: "オンラインチャネルから予約がプッシュ/プルされた",
    CHANGE_TYPE_3: "部屋タイプの有効化/無効化",
    CHANGE_TYPE_4: "動的料金計算式の作成/修正",
    CHANGE_TYPE_5: "部屋料金の変更",
    CHANGE_TYPE_6: "部屋のクローズ/オープン",
    SCHEDULE_DYNAMIC_PRICING: "動的販売設定",
    HAVE_BEEN_CONNECTED_TO_DYNAMICPRICING: "動的料金が設定されているため削除できません",
    SERVICE_INCLUDES: "サービス内容",
    CHAIN_INFO: "チェーン概要",
    CHAIN_ROOM_TYPE: "チェーン部屋タイプ",
    CHAIN_RATE_PLAN: "チェーン料金プラン",
    CHAIN_ROOM_TYPE_AMENITY: "チェーン部屋アメニティ",
    CHAIN_SERVICE: "チェーンサービス",
    CODE_NOT_VALIDATE: "コードが無効です",
    PAYMENT_CODE: "支払いコード",
    PAYMENT_TYPE: "取引タイプ",
    PAYMENT_STATUS: "取引ステータス",
    PAYMENT: "支払い",
    REFUND: "返金",
    CANCELLATION_REFUND: "キャンセル返金",
    CANCELLATION_FEE: "キャンセル料金",
    WAITING_PAYMENT: "保留中",
    SUCCESS_PAYMENT: "成功",
    FAILED: "失敗",
    CHAIN_NOT_EXIST: "チェーンが存在しません",
    CHAIN_TRAVEL_AGENT: "チェーン会社およびエージェント情報",
    HOTEL_TRAVEL_AGENT: "ホテル会社およびエージェント情報",
    BE_MANAGEMENT: "ezBe",
    THE_SYSTEM_IS_LOADING: "システムを読み込み中です。お待ちください",
    OTA_HOTEL_NOT_FOUND: "OTAホテルが見つかりません",
    ROOM_CLASS_MAPING: "部屋タイプのマッピング",
    CONFIRM_SAVE: "接続情報を変更しました。この操作により、接続の損失や予約のマッピングが外れる可能性があります",
    UNDO: "元に戻す",
    CONFIRM_UNDO: "直前の変更は保存されません。元に戻してもよろしいですか？",
    DEFAULT_LANGUAGE: "メイン言語",
    RE_SYNC_CONNECT: "再同期",
    ez_FOLIO: "ezFolio",
    ez_CLOUDHOTEL: "ezCloudHotel",
    ADVANCE_SEARCH: "高度な検索",
    PRICE_OR_OTA_IS_REQUIRED: "販売価格または販売チャネルは必須です",
    UPDATE_BY_ROOM_TYPE: "部屋タイプごとに更新",
    UPDATE_BY_SALE_PACKAGE: "販売パッケージごとに更新",
    UPDATE_BY_SALE_CHANNEL: "OTAチャネルごとに更新",
    BULK_DELETE: "一括削除",
    CONFIRM_UPDATE_OVERWRITE: "選択したすべての販売チャネルの価格と含まれる人数を上書きする更新確認",
    ONLY_UPDATE_PRICE: "価格のみ上書き",
    DAILY_MASTER_RATE: "日次派生料金",
    NUMBER_NIGHT: "泊",
    NUMBER_ROOM: "部屋数",
    ROOM_CAP: "0部屋 | 1部屋 | {count}部屋",
    BOOKING_CAP: "0件の予約 | 1件の予約 | {count}件の予約",
    CHECKIN_STATUS_RESERVED: "予約済み",
    CHECKIN_STATUS_CHECKIN: "チェックイン",
    CHECKIN_STATUS_CHECKOUT: "チェックアウト",
    CHECKIN_STATUS_NO_SHOW: "ノーショー",
    CHECKIN_STATUS_ARRIVAL: "到着",
    CHECKIN_STATUS_DUE_OUT: "チェックアウト予定",
    CHECKIN_STATUS_CANCELLED: "キャンセル済み",
    NAME_OF_GUEST_STAYING: "滞在者名",
    PRICE_EXTRA_DAILY: "追加日料金",
    CHANNEL: "0チャネル | 1チャネル | {count}チャネル",
    ASSIGN_RATE_TO_CATEGORY: "料金プランをカテゴリーに割り当て",
    _CATEGORY: {
        CODE: "カテゴリーコード",
        NAME: "カテゴリー名",
        DESCRIPTION: "説明"
    },
    ASSIGN_HOTEL_TO_CATEGORY: "ホテルにカテゴリを割り当て",
    CHAIN_REGIS_INFO: "チェーン登録情報",
    CONFIRM_DELETE_RATE_CATEGORY: "料金カテゴリの削除確認",
    RATE_CATEGORY_ALREADY_EXIST: "料金カテゴリはすでに存在しています",
    RATE_PLAN_DOES_NOT_EXIST: "料金プランが存在しません",
    CANCEL_REASON: "キャンセル理由",
    RATE_PMS: "PMS販売価格",
    ALL_PLAN: "すべての料金プラン",
    ALL_RATE_CATEGORY: "すべての料金カテゴリ",
    TO_PAGE: "1から{count}までのリスト",
    ASSIGN_ROOM_TYPE: "部屋タイプの割り当て",
    CONFIG_RATE_OTA: "OTA料金設定",
    CONFIG_RATE_PMS: "PMS料金設定",
    UPDATE_RATE_PMS: "価格を更新",
    VIEW: "表示",
    CONFIRM_DELETE_SALE_PACKAGE_DATE_RANGE_PMS: "選択した期間の価格は、他の部屋タイプおよび販売パッケージで削除されます。<br>分割価格を削除してもよろしいですか？",
    WAITING_UPDATE: "データが記録され、処理中です",
    STATUS_ROOM_TYPE_ON_OTA: "OTAでの接続ステータス",
    BOOKING_LIST_GROUP: "グループ予約",
    _GROUP_STATUS: {
        HOLD: "保留",
        TENTATIVE: "仮予約",
        CONFIRMED: "確定",
        CANCELED: "キャンセル済み",
        CHECKED_IN: "チェックイン済み",
        CHECKED_OUT: "チェックアウト済み",
        CLOSE: "クローズ",
        NO_SHOW: "ノーショー"
    },
    _BOOKING_GROUP: {
        BOOKING_GROUP_NAME: "グループ予約名",
        BOOKING_GROUP_CODE: "グループ予約コード",
        GROUP_PROFILE_NAME: "グループプロフィール名",
        GROUP_PROFILE_CODE: "グループプロフィールコード",
        BOOKING_GROUP_START_DATE: "開始日",
        BOOKING_GROUP_END_DATE: "終了日",
        BOOKING_GROUP_CREATE_DATE: "作成日",
        STATUS: "グループステータス"
    },
    ENTER_TEXT: "{text}を入力",
    LIST_PROFILE_GROUP: "グループプロファイル一覧",
    PROFILE_GROUP: "グループプロファイル",
    SEARCH_BY_PROFILE_NAME_AND_CODE: "プロフィール名、プロフィールコード、メール、住所で検索",
    BOOKINGS_GROUP: "グループ予約数",
    PROFILE_NUMBER: "{count}件のプロファイル",
    _GROUP: {
        CONFIRM_DELETE: "グループ記録の削除を確認",
        DETAIL: "チームプロファイルの詳細",
        INFO: "プロファイル情報",
        INFO_MANAGE: "管理情報",
        ASSIGN: "割り当て",
        GROUP_PROFILE_NAME: "プロフィール名",
        GROUP_PROFILE_NAME_OTHER: "他の名前",
        COMPANY_NAME: "会社/代理店名",
        DESCRIPTION: "説明",
        CONTACT_NAME: "代表者名",
        PHONE_NUMBER: "電話番号",
        PHONE_NUMBER_OTHER: "別の電話番号",
        MANAGE_NAME: "管理者氏名",
        DETAIL_BOOKING: "グループ予約の詳細",
        GROUP_INFO: "グループ情報",
        LEADER: "リーダー",
        PMS_CCODE: "PMSコード",
        CUS_OF_DAYS: "切り離し日数",
        CUT_OF_DATE: "切り離し日",
        PAYMENT_INFO: "支払い情報",
        TOTAL: "合計金額",
        UPDATE_PROFILE: "クループロファイルの更新",
        PAYMENT_METHOD: "支払い方法",
        PAYMENT_METHOD_BOOKING_RETAIL: "個別支払い方法",
        BOOKING_GROUP_INFO: "グループ予約情報",
        LEADER_NOT_PAY: "リーダーが支払わない",
        LEADER_PAY_ONE_PART: "パーティ支払いリーダー",
        LEADER_PAYS_ALL: "全額支払いリーダー",
        CHOOSE_PROFILE: "連合プロフィールを選択",
        TITLE: "タイトル"
    },
    ROOM_OF_LEADER: "リーダーの部屋",
    NUMBER_OF_BOOKING: "予約数",
    SUB_BOOKING_CODE: "サブグループコード",
    UPDATE_INFO_BOOKING_GROUP: "グループ予約ファイル情報を更新",
    ALLOW_OVERWRITING_INFOMATION_DOWN: "情報の上書きを許可",
    FILTER: "フィルター",
    GROUP_PROFILE: "グループプロファイル",
    BOOKING_GROUP_PROFILE: "グループ予約",
    ASSIGN_HOTEL: "ホテルの割り当て",
    ASSIGN_ROOM_TO_CATEGORY: "部屋をカテゴリに割り当て",
    UPDATE_ROOM_RATE_PMS: "PMS料金設定",
    UPDATE_ROOM_RATE_OTA: "OTA料金設定",
    BOOKING_UNMAP: "予約のマッピング解除",
    CONFIRM_DELETE_ROOM_CATEGORY: "部屋カテゴリ削除の確認",
    CHAIN_ROOM_CATEGORY_ALREADY_EXIST: "チェーン部屋カテゴリはすでに存在しています",
    ROOM_CATEGORY_ALREADY_EXIST: "部屋カテゴリはすでに存在しています",
    ASSIGN_OTA: "チャネル割り当て",
    NOTE_ASIGN_OTA: "注: 保存を押すと、販売チャネルは選択された部屋カテゴリに自動的に割り当てられ、チャネルに登録されているホテルと同期されます。",
    ACTION_TIME: "更新時刻",
    PROCESS_TIME: "処理時間",
    IGNORE: "無視",
    RESEND: "再更新",
    LIST_ACTION_PROCESS: "未完了のアクション",
    STATUS_PROCESSING: "処理中",
    STATUS_FAILED: "失敗",
    STATUS_DONE: "完了",
    UPDATE_RATE: "料金を更新",
    UPDATE_RATE_SPECIAL: "日別料金を更新",
    UPDATE_EXTRA_RATE: "追加料金を更新",
    UPDATE_EXTRA_SPECIAL_RATE: "日別追加料金を更新",
    UPDATE_AVAIL: "在庫を更新",
    UPDATE_RESTRICTION: "制限を更新",
    PROCESS_CAP: "0プロセス | 1プロセス | {count}プロセス",
    CONFIRM_IGNORE: "エラー操作は再度更新されません。本当にスキップしますか？",
    HOTEL_BOOKING_UNMAP_REPOST: "予約を再投稿",
    UPDATE_RESTRICTION_MINSTAY: "最小宿泊数を更新",
    UPDATE_RESTRICTION_MAXSTAY: "最大宿泊数を更新",
    UPDATE_RESTRICTION_MINSTAYARRIVAL: "到着時最小宿泊数を更新",
    UPDATE_RESTRICTION_MAXSTAYARRIVAL: "到着時最大宿泊数を更新",
    UPDATE_RESTRICTION_MINBOOKINGWINDOW: "最小予約ウィンドウを更新",
    UPDATE_RESTRICTION_MAXBOOKINGWINDOW: "最大予約ウィンドウを更新",
    UPDATE_RESTRICTION_EXACTSTAY: "正確な宿泊数を更新",
    UPDATE_RESTRICTION_EXACTSTAYARRIVAL: "到着時正確な宿泊数を更新",
    UPDATE_RESTRICTION_CLOSEDONARRIVAL: "チェックインを許可しないを更新",
    UPDATE_RESTRICTION_CLOSEDONDEPARTURE: "チェックアウトを許可しないを更新",
    UPDATE_RESTRICTION_CLOSED: "販売停止を更新",
    DELETE_PRICE_SPECIAL: "日別料金を削除",
    DELETE_EXTRA_RATE: "追加料金を削除",
    DELETE_EXTRA_SPECIAL_RATE: "日別追加料金を削除",
    HOTEL_DASHBOARD_IGNORE_TASK: "タスクを無視",
    HOTEL_DASHBOARD_REUPDATE_TASK: "タスクを再更新",
    CHAIN_ROOM_UPDATE_QUANTITY: "部屋数を更新",
    ROOM_UPDATE_QUANTITY: "部屋数を更新",
    CHAIN_ROOM_CATEGORY: "部屋カテゴリ - チェーン",
    HOTEL_ROOM_CATEGORY: "部屋カテゴリ",
    HOTEL_RATE_CATEGORY: "料金カテゴリ",
    CHAIN_RATE_CATEGORY: "料金カテゴリ - チェーン",
    ERROR_CAUSE: "エラー原因",
    INVENTORY_NOT_SYNC: "空室が同期されていません",
    UNKNOWN_ERROR: "不明なエラー",
    BY_RATE: "定価による",
    BY_FORMULA: "計算式による",
    CONFIG_TYPE: "設定タイプ",
    FOMULA_FROM_TO: "月曜から日曜までの価格計算式",
    CONFIRM_DEACTIVE_DYNAMIC_RESTRICTION: "動的制限の無効化確認",
    EDIT_DYNAMIC_RESTRICTION: "動的制限テンプレートを編集",
    ADD_NEW_DYNAMIC_RESTRICTION: "新しい動的制限テンプレートを追加",
    DYNAMIC_RESTRICTION: "動的制限",
    CONFIRM_DELETE_DYNAMIC_RESTRICTION: "動的制限テンプレートの削除確認",
    DYNAMIC_RESTRICTION_NAME: "動的制限テンプレート名",
    DYNAMIC_RESTRICTION_DESCRIPTION: "動的制限テンプレートの説明",
    RESTRICTION_CALCULATION_FORMULA: "設定情報",
    NO_CHANGE: "変更なし",
    ADULT_CAP: "0大人 | 1大人 | {count}大人",
    CHILD_CAP: "0子供 | 1子供 | {count}子供",
    BABY_CAP: "0赤ちゃん | 1赤ちゃん | {count}赤ちゃん",
    USE_MODEL: "モデルとして使用",
    ADD_RANGE: "範囲を追加",
    MODEL_DESCRIPTION_RESTRICTION: "価格/価格式/容量範囲/制限が選択された場合、以下の部屋タイプおよび販売パッケージにコピーされます。",
    MODEL_DESCRIPTION_PRICE: "価格/価格式/容量範囲/制限が選択された場合、以下の部屋タイプおよび販売パッケージにコピーされます。",
    NOTE_ROOM_RATE: "B: 部屋タイプに応じた部屋料金。部屋販売画面で料金が表示および更新されます。新しい部屋料金を作成すると、デフォルトで部屋タイプの部屋料金が適用されます。",
    DYNAMIC_SALE: "動的部屋販売",
    NOTE_MODEL_PRICE: "テンプレートからコピーされた部屋タイプを編集できます。",
    ACCOUNT_UPDATE: "アカウント更新",
    ITEMS_PER_PAGE: "1ページあたりの行数",
    UPDATE_RATE_SPECIAL_FROM_CHAIN: "チェーンからの料金更新",
    EQUIVALENT_TO_ROOM_NIGHT: "部屋泊数に相当",
    CREATED_BY_ACCOUNT: "アカウントによって作成",
    IS_LEGACY_ROOM_CLASS: "部屋タイプおよび料金プランが派生しているため削除できません",
    ASSIGN_RATE_CATEGORY: "料金カテゴリを割り当て",
    ASSIGN_ROOM_CATEGORY: "部屋カテゴリを割り当て",
    CUSTOMER_PHONE: "顧客の電話番号",
    CUSTOMER_MAIL: "顧客注文のメール",
    DU_DESCRIPTION_OF_ROOM_TYPE: "日帰り予約（到着日＝出発日）",
    DU_DESCRIPTION_OF_HOTEL: "ホテルの日帰り予約（到着日＝出発日）",
    OVERVIEW: "概要",
    INDEX_P: "稼働率 (P)",
    INDEX_P_ROOM: "部屋タイプ別の稼働率",
    INDEX_P_HOTEL: "ホテル別の稼働率",
    INDEX_A: "販売済み客室数（Day Useを含む）(A)",
    INDEX_B: "販売可能客室数 (B)",
    INDEX_DU: "販売済み客室数 (Day Use) (DU)",
    INDEX_INV: "販売可能な部屋",
    BY_ROOM: "部屋タイプ別",
    BY_HOTEL: "ホテル別",
    DYNAMIC_NAME_HAS_EXIST: "動的名が既に存在します",
    ROOM_SALE_WITH_ROOM_TYPE: "部屋タイプで表示",
    ROOM_SALE_WITH_OTA: "チャネル別で表示",
    ROOM_FUND: "アロットメント",
    NODATA_2: "2文字以上を入力してください",
    CHOOSE_MARKET_SEGMENT: "市場セグメントを選択",
    MARKET_SEGMENT: "市場セグメント",
    TRAVEL_AGENT_SPEC: "特定エージェント",
    SEGMENT_SPEC: "特定市場セグメント",
    SHOW_CARD_PAYMENT_INFO: "カード情報を表示",
    ENTER_TO_SEARCH_MORE: "さらに検索するために入力",
    EMAIL_ACCESSTOKEN: "カード情報アクセスコード受信メール",
    TEXT_NOTIFY_EXPIRED_GROUP_OTA: "{channel} 機能は {date} に期限切れとなりました",
    TEXT_NOTIFY_WILL_EXPIRE_GROUP_OTA: "{channel} 機能は {date} に期限切れとなります",
    PLEASE_RENEW: "更新してください。サポートはメール <u>hotro@ezcloud.vn</u> またはホットライン <u>1900 9013</u> にお問い合わせください。",
    NOTIFY_OFF_MODULE: "部屋タイプ別販売機能は近いうちに停止します。ご意見は <b>hotro@ezcloud.vn</b> までお送りください。",
    NEW_MESSAGE: "新しいメッセージ",
    PAXONE: "1人料金",
    PAXTOW: "2人料金",
    PAXEXTRA: "追加1人料金",
    MAP_PRODUCT: "商品を割り当て",
    UPDATE_RESTRICTION_BY_RATE_PLAN: "制限を更新",
    CREATE_RESTRICTION: "制限を作成",
    DELETE_ROOM_RATE: "部屋料金を削除",
    UPDATE_SPECIAL_RATE: "日別料金を更新",
    HERE: "こちら",
    ACCESS_TOKEN_EMAIL_IS_NOT_EMPTY: "カード情報受信用のメールを追加してください",
    ADD_PROGRAM: "プログラムを追加",
    TYPE_APPLY_PROMOTION: "プロモーションシステム",
    PROMOTION_CHARCE_COUPON: "プロモーション、割引コード",
    PROMOTION_CHARGE: "プロモーション適用",
    COUPON_APPLY: "割引コード適用",
    EZ_PROMOTION_NOT_SUPPORTED_PROMOTION_TYPE: "ezPromotionシステムはこのプロモーションタイプをサポートしていません",
    ERROR_EZ_PROMOTION: "ezPromotionシステムに接続できません",
    CANCEL_PROMOTION_ERROR: "プロモーションのキャンセルに失敗しました",
    CONFIRM_PROMOTION_ERROR: "プロモーションの確認に失敗しました",
    RELOAD: "リフレッシュ",
    WARNING: "警告",
    TXT_WARNING_OVER: "システム性能を確保するため、1操作につき50行以上の更新は避けてください。",
    CONFIRM_DELETE_DATA_ENTERED: "マスタープロダクトを変更しました。入力した価格データを削除しますか？",
    ROOM_STATUS_1: "予約済み",
    ROOM_STATUS_2: "チェックイン済み",
    ROOM_STATUS_3: "チェックアウト済み",
    ROOM_STATUS_4: "ノーショー",
    ROOM_STATUS_5: "キャンセル済み",
    BOOKING_HISTORY: "予約履歴",
    BOOKING_STATUS_OTA: "OTAからの予約ステータス",
    BOOKING_OTA_STATUS_0: "新規予約",
    BOOKING_OTA_STATUS_1: "変更予約",
    BOOKING_OTA_STATUS_2: "キャンセル予約",
    BOOKING_OTA_STATUS_3: "転送予約",
    COPY_RATE: "料金プランを複製",
    SALE_PACKAGE_CODE_NEW: "新料金プランコード",
    SELLING_PACKAGE_NEW: "新料金プラン名",
    DUPLICATE: "複製",
    SALE_PACKAGE_CODE_OLD: "旧料金プランコード",
    FAST_UPDATE: "迅速更新",
    AUTO_CANCEL_PAYMENT_FAIL: "支払い失敗時に自動キャンセルを許可",
    EZPAYREF: "参照コード",
    TOOLTIP_AUTO_CANCEL_PAYMENT_FAIL: "この機能を有効にすると、支払い失敗状態が一定時間続いた予約を自動的にキャンセルします。デフォルト時間は30分です。空白の場合、適用値は0分です。",
    TOOLTIP_AUTO_CANCEL: "特定の日付までの事前支払いが必要な予約において、現金や銀行振込などezCrsで記録できない形式で支払いを受けた場合、ホテルが確認する必要があります。この機能を有効にすると、未確認予約を自動的にキャンセルします。",
    CONFIG_BY: "設定者",
    LIST_FORMULAR: "計算式一覧",
    ROOM_TYPE_BASE: "基本部屋タイプ",
    SALE_PACKAGE_BASE: "基本料金政策",
    SALE_CHANNEL_BASE: "基本販売チャネル",
    ROOM_TYPE_DERIVED: "派生部屋タイプ",
    SALE_PACKAGE_DERIVED: "派生料金プラン",
    SALE_CHANNEL_DERIVED: "派生販売チャネル",
    HOTEL_LOG_derivationType: "派生タイプ",
    HOTEL_LOG_formulaType: "タイプ",
    HOTEL_LOG_master: "マスター",
    HOTEL_LOG_children: "子",
    HOTEL_LOG_formula: "計算式",
    HOTEL_ROOM_TYPE_SPECIAL: "部屋料金を更新",
    UPDATE_ROOM_TYPE: "部屋タイプを更新",
    TOOLTIP_BASE_ROOM_TYPE: "派生タイプ内の部屋タイプ製品で、料金プランと販売チャネルが部屋タイプ {value} の製品と一致するもののみ、計算式に基づいて派生されます。",
    TOOLTIP_BASE_RATE_PLAN: "派生料金プラン内の料金プラン製品で、部屋タイプと販売チャネルが料金プラン {value} の製品と一致するもののみ、計算式に基づいて派生されます。",
    TOOLTIP_BASE_OTA: "派生チャネル内の販売チャネル製品で、料金プランと部屋タイプが販売チャネル {value} の製品と一致するもののみ、計算式に基づいて派生されます。",
    VALUE_AND_PERSON_IS_REQUIRED: "価格とゲストの人数を入力してください",
    PLS_CHOOSE_ONE_SELECT_BOX: "更新するには少なくとも1つの「削除」ボックスを選択してください",
    NOTE_DERIVED: "新しい派生計算式が、派生または基本製品のいずれかと一致する場合、前の計算式を上書きします",
    ROOM_QUANTITY_PARENT_NOT_SAME: "親部屋と子部屋の部屋タイプ数が同じである必要があります",
    IS_REDIRECTING: "リダイレクト中",
    MAP: "マップ",
    SYNC_FROM_PRICELABS: "Pricelabsから同期",
    HOTEL_EXTRA_SPECIAL_RATE_DELETE: "日別追加料金を削除",
    HOTEL_EXTRA_SPECIAL_RATE_UPDATE: "日別追加料金を更新",
    SYNC_DATA_TO_OTA: "OTAへデータを同期",
    MODULE_EZ_PAYMENT_NOT_ACTIVE: "モジュールezPaymentがアクティブではありません",
    NOT_DELETE_ROOM_TYPE_CODE_HAS_SYNCED_TO_OTA: "OTAと接続されている部屋タイプを削除できません",
    ENABLE_SYNC_NOT_UPDATED: `部屋タイプが現在OTAと接続されています。部屋タイプの人数を変更するには、以下の手順に従ってください。変更により接続に影響が出る可能性があります。<br><br>\
    <span class="font-weight-bold">手順1:</span> 同期管理にアクセス => ezCms vela+ を選択 => OTAマッピングタブを選択し、変更したい部屋タイプをすべての接続中OTAチャネルから切断します。<br>\
    <span class="font-weight-bold">手順2:</span> チャネルタブを選択し、変更したい部屋タイプを切断します。<br>\
    <span class="font-weight-bold">手順3:</span> 人数を変更し、OTAチャネルを再接続します。<br><br>\
    <span class="font-weight-bold">注意:</span> 順序通りに手順を実行しないと、接続エラーにより収益損失が発生する可能性があります。<br>\
    詳細は <a href="https://help.ezcms.vn/tich-hop-he-thong-ezcms-vela/" target="_blank"><u>こちら</u></a> をご覧ください。`,
    ENABLE_SYNC_NOT_CREATED: `部屋タイプコードがホテルレベルで既に存在しているため、OTAと接続されているため変更できません。 \
    部屋タイプコードを変更するか、この部屋タイプのチェーンまたはホテルでの人数を調整してください。`,
    UNDERSELL_LIMIT_TITLE: "チャネルごとの販売可能な部屋のしきい値を設定し、販売を管理します。特定チャネルの販売可能部屋数がこのしきい値に達すると、販売停止がトリガーされます。",
    SELL_LIMIT_TITLE: "チャネルグループごとの最大販売部屋数を設定し、販売を管理して収益を最適化します。",
    ROOM_FOR_SALE: "販売可能な部屋",
    NO_CHANNEL_GROUP: "更新するチャネルグループを選択してください",
    DATA_BLANK: "入力データを空欄にしないでください",
    ROOM_QUANTITY_PARENT_NOT_SAME: "親部屋と子部屋の部屋タイプ数が一致している必要があります",
    VALUE_MUST_BE_LESS_THAN_24H: "値は24時間未満である必要があります",
    N_O: "番号",
    MASTER_ROOM_TYPE: "マスター部屋タイプ",
    MASTER_RATE_PLAN: "マスター料金プラン",
    MASTER_CHANNEL: "マスターチャネル",
    DERIVED_ROOM_TYPE: "派生部屋タイプ",
    DERIVED_RATE_PLAN: "派生料金プラン",
    DERIVED_CHANNEL: "派生チャネル",
    MASTER_PRODUCT: "マスタープロダクト",
    FORMULAR_LIST: "計算式一覧",
    DERIVED_PRODUCT: "派生プロダクト",
    PRICE_FORMULA: "料金計算式",
    SELECT_TYPE: "タイプを選択",
    SHOW_MORE_FOMULA: "さらに計算式を表示",
    SELECT_TYPE_RESTRICTION: "制限タイプを選択",
    SETUP_FORMULAR_LIST: "計算式リストを設定",
    APPLY_DATE: "適用日",
    LIST_FROM: "一覧開始",
    TO: "終了",
    IN: "で",
    NO_TYPE_SELECTED: "計算式を作成するには、料金または制限タイプを選択してください",
    ROOM_TYPE_NOT_MATCH: "料金プランまたはチャネルが基本製品と派生製品の間で一致しないため、計算式を設定できません。再確認するか、対応する製品を作成してください。",
    SALE_PACKAGE_NOT_MATCH: "部屋タイプまたはチャネルが基本製品と派生製品の間で一致しないため、計算式を設定できません。再確認するか、対応する製品を作成してください。",
    SALE_CHANNEL_NOT_MATCH: "料金プランまたは部屋タイプが基本製品と派生製品の間で一致しないため、計算式を設定できません。再確認するか、対応する製品を作成してください。",
    CUSTOM_NOT_MATCH: "部屋タイプ、料金プラン、またはチャネルがマスター製品と子製品の間で互換性がないため、計算式が確立されていません。",
    CHANGE: "変更",
    CURRENT_FORMULA: "現在の計算式",
    NEW_FORMULA: "新規計算式",
    MODIFIED_FORMULA: "修正計算式",
    DELETED_FORMULA: "削除された計算式",
    DERIVED: "派生",
    LIST_FORMULAR_UPDATE: "更新された計算式",
    BEFORE: "前",
    AFTER: "後",
    ROOM_RATE_DERIVATIONS_NOT_FOUND: "部屋料金の派生が見つかりません",
    UPDATE_RESTRICTION_MINBOOKINGWINDOWBYHOUR: "最小予約ウィンドウ（時間単位）を更新",
    UPDATE_RESTRICTION_MAXBOOKINGWINDOWBYHOUR: "最大予約ウィンドウ（時間単位）を更新",
    NUMBER_OF_DAYS: "日数",
    NUMBER_OF_HOURS: "時間数",
    REMOVE_DAYLY_RATE: "日別料金を削除",
    ALLOW_CHECKIN: "チェックインを許可",
    ALLOW_CHECKOUT: "チェックアウトを許可",
    QUICK_UPDATE: "タイプを更新",
    BASE_PRICE_REQUIRED: "まず週別料金を更新してください",
    CALENDAR_ROOM: "カレンダー表示",
    WARNING_EMAIL: "メール",
    SAFE_PRICE_RANGE: {
        PROTECTION_RATE: "保護率",
        PROTECTION_RATE_TOOLTIP: "保護率とは、ルームセールの入力データが設定した最低料金未満または最大料金を超えた場合に保存が許可されない料金範囲です。",
        MINIMUM_RATE: "最低料金",
        MAXIMUM_RATE: "最大料金",
        MINIMUM_RATE_INVALID: "最低料金は最大料金を超えることはできません",
        MAXIMUM_RATE_INVALID: "最大料金は最低料金を下回ることはできません",
        PROTECTION_RATE_INPUT_INVALID: "入力値は{priceMin}未満または{priceMax}を超えることはできません",
        MINIMUM_RATE_INPUT_INVALID: "入力値は{priceMin}未満であってはなりません",
        MAXIMUM_RATE_INPUT_INVALID: "入力値は{priceMax}を超えてはなりません",
    },
    PRICE_OUT_OF_BOUND: "入力料金が保護率を超えました",
    PRICE_UPDATE_OUT_OF_BOUND: "現在の販売料金が保護率を超えました",
    INCLUDED_TAX: "税込",
    ACTIVATE: "アクティベート",
    NO_RANK: "ランクなし",
    ONE_STAR: "1つ星",
    TWO_STAR: "2つ星",
    THREE_STAR: "3つ星",
    FOUR_STAR: "4つ星",
    FIVE_STAR: "5つ星",
    EXAMPLE_INFO: `<p><i><u><span>例:</span></u></i></p> 
    <p>ホテルが使用している通貨: <span>VND</span></p> 
    <p>デラックスルームの申告価格: <span>900,000</span></p> 
    <p>為替レート: <span>0.00005</span></p> 
    <p>価格差: <span>0.5</span></p> 
    <p>同期後、OTAチャネルでのデラックスルーム販売価格は: <span>(900,000 x 0.5) + 0.5 = 50 $</span></p>`,
    FREE_SALE_ALLOTMENT: "カットオフ日までのフリーセール割当",
    ACTIVITY_LOG: "0件のログ | 1件のログ | {count}件のログ",
    TIPS: "ヒント",
    _CONFIGURATION: {
        MENU: "メニュー",
        WIDGET: "ウィジェット",
        THEME: "テーマ",
        SCRIPT: "スクリプト",
        MENU_HEADER: "メニューヘッダー",
        MENU_FOOTER: "メニューフッター",
        LOGO: "ロゴ",
        HEADER: "ヘッダー",
        BE_CONTENT: "BEコンテンツ",
        FOOTER: "フッター",
        FOOTER_BOTTOM: "フッターボトム",
        FOOTER_RIGHT: "フッター右",
        WIDGET_FOOTER_RIGHT: "ウィジェット フッター右",
        WIDGET_FOOTER_BOTTOM: "ウィジェット フッターボトム",
        WIDGET_SOCIAL_MEDIA_ICON: "ウィジェット: ソーシャルメディアアイコン",
        WIDGET_HTML_TEXT: "ウィジェット: HTMLテキスト",
        SCRIPT_WILL_ADD_BODY: "<body>内にスクリプトが追加されます",
        SCRIPT_WILL_ADD_HEAD: "<head>内にスクリプトが追加されます",
        TEMPLATE: "テンプレート",
        BODY: "ボディ",
        BE_SUPPORT: `<p class="fs-14"><b>方法1： 事前作成されたフォームを使った統合</b></p>
        <p>この機能は、Booking Engineをあなたのウェブサイトと統合することができ、具体的にはウェブサイトにBooking Engineの予約フォームを表示することができます。</p>
        <img src="/script-BE.png">
        <br>
        <p><b>ステップ1：</b> 下記のHTMLコードをコピーして、ウェブサイトの予約フォームを表示したい場所に貼り付けてください。</p>
        <div>
            <i>&lt;div class="booking-form"&gt;&lt;/div&gt;</i>
        </div>
        <div class="mt-3">
            <p><b>ステップ2：</b> 下記のスクリプトをコピーして、ウェブサイトのフッター（bodyタグの閉じタグの前）に貼り付けてください。</p>
            <p>1. ウェブサイトにjqueryがない場合：</p>
            <i> &emsp;&lt;script src="https://apps.oneinventory.com/plugins/ezbe-chain-jquery-5s.js"&gt;&lt;/script&gt; <br>
            &emsp;&lt;script&gt;<br>
            &emsp;&emsp;create_booking_form('XXXXXX', '.booking-form', 'vi', 'VND', 'horizontal', '#ffffff', '#fc5b62');<br>
            &emsp;&lt;/script&gt;<br></i>
        </div>
        <div class="mt-3">
            <p>2. ウェブサイトにjqueryが既にある場合（スクリプトの競合が発生する場合）：</p>
            <i>&emsp;&lt;script src="https://apps.oneinventory.com/plugins/ezbe-chain-5s.js"&gt;&lt;/script&gt; <br>
            &emsp;&lt;script&gt; <br>
            &emsp;&emsp;create_booking_form('XXXXXX', '.booking-form', 'vi', 'VND', 'horizontal', '#ffffff', '#fc5b62'); <br>
            &emsp;&lt;/script&gt; <br></i>
        </div>
        <br>
        <p><b>ステップ3：</b> 保存する前に、<b>create_booking_form</b>関数のパラメーターをウェブサイトに適合するようにカスタマイズしてください。</p>
        <p class="mb-1"><b>その場合：</b></p>
        <div class="ml-3">
            <p class="mb-1"><i>XXXXXX</i> : あなたのホテルコード（必須）。</p>
            <p class="mb-1"><i>.booking-form</i> : ステップ1で宣言されたHTML要素のid（#）またはclass（.）（必須）。</p>
            <p class="mb-1"><i>vi</i> : 表示する言語コード（オプション）。サポートされているコードは2つです：</p>
                <p class="mb-1 ml-5"><i>vi</i> : ベトナム語</p>
                <p class="mb-1 ml-5"><i>en</i> : 英語</p>
            <p class="mb-1"><i>VND</i> : Booking Engineに表示される通貨単位コード、国際的な通貨コード基準に従います（オプション）。</p>
            <p class="mb-1"><i>horizontal</i>: フォームの表示スタイル（カスタマイズ可能）。サポートされているスタイルは2つです：</p>
            <p class="mb-1 ml-5"><i>horizontal</i>: 横向き表示</p>
            <p class="mb-1 ml-5"><i>vertical</i>: 縦向き表示</p>  
            <p class="mb-1"><i>#ffffff</i> : 部屋検索ボタンの文字色のカラーコード（オプション）。</p>
            <p class="mb-1"><i>#fc5b62</i> : 部屋検索ボタンの背景色のカラーコード（オプション）。</p>
        </div>
        <hr>
        <p class="fs-14"><b>方法2： URLリンクを使った統合</b></p>
        <p>URLをボタンまたはリンクテキストに割り当てます。以下のサンプルURLを使用してください：</p>
        <div>
            <i>https://booking.ezcms.vn/hotel/BeDetailHotel?hotel_code=XXXXXX&check_in=2020-11-30&check_out=2020-12-01&num_of_rooms=1&num_of_adults=2&num_of_children=0&promo_code=&rate_code=&room_code=&lang=vi&amp;currency=VND</i>
        </div>
        <br>
        <p class="mb-1"><b>その場合：</b></p>
        <div class="ml-3">
            <p class="mb-1"><i>hotel_code</i>: あなたのホテルコード（必須）</p>
            <p class="mb-1"><i>check_in</i>: チェックイン日（YYYY-MM-DD形式）（オプション）</p>
            <p class="mb-1"><i>check_out</i>: チェックアウト日（YYYY-MM-DD形式）（オプション）</p>
            <p class="mb-1"><i>num_of_rooms</i>: 部屋数（オプション）</p>
            <p class="mb-1"><i>num_of_adults</i>: 大人の人数（オプション）</p>
            <p class="mb-1"><i>num_of_children</i>: 子供の人数（オプション）</p>
            <p class="mb-1"><i>room_code</i>: 部屋タイプコード（オプション）</p>
            <p class="mb-1"><i>rate_code</i>: 料金ポリシーコード（オプション）</p>
            <p class="mb-1"><i>promo_code</i>: プロモーションコード（オプション）</p>
            <p class="mb-1"><i>lang</i> : 表示する言語コード（オプション）</p>
            <p class="mb-1"><i>currency</i> : 表示される通貨単位コード（オプション）</p>
        </div>
        <hr>
        <p class="fs-14"><b>方法3：ホテルのウェブサイトに直接統合する</b></p>
        <p>この機能を使用すると、Booking Engine をホテルのウェブサイトに統合できます。具体的には、ホテルのウェブサイト上に Booking Engine の部屋リストを表示します。</p>
        <p class="mb-3">
            <b>ステップ1：</b> 以下のサンプル HTML をコピーして、予約フォームを表示したい位置に貼り付けます。<br/>
            <i>&lt;div class="booking-form"&gt;&lt;/div&gt;</i>
        </p>
        <p class="mb-3">
            <b>ステップ2：</b> 以下のスクリプトをコピーして、ウェブサイトのフッター（body タグの直前）に貼り付けます。<br/>
            <i> &emsp;&lt;script src="https://app.oneinventory.com/booking-engine/plugins/ezbe-embed.js"&gt;&lt;/script&gt; <br>
                &emsp;&lt;script&gt;<br>
                &emsp;&emsp;window.initBookingForm({<br>
                &emsp;&emsp;&emsp; hotel: [{ hotelName: 'Hotel A', hotelCode: 'KSA' }],<br> 
                &emsp;&emsp;&emsp; target: '.booking-form',<br>
                &emsp;&emsp;&emsp; path: '/room-list',<br>
                &emsp;&emsp;&emsp; lang: 'ja',<br>
                &emsp;&emsp;&emsp; background: '#ffffff',<br>
                &emsp;&emsp;&emsp; buttonBackground: '#ff0000',<br>
                &emsp;&emsp;&emsp; buttonTextColor: 'white',<br>
                &emsp;&emsp;&emsp; textColor: '#333333'<br>
                &emsp;&emsp; });<br>
                &emsp;&lt;/script&gt;<br>
            </i>
        </p>
        <p class="mb-0">
            <b>ステップ3：</b> <b>window.initBookingForm</b> 関数のパラメータをホテルのウェブサイトに合わせて調整し、保存してください。
        </p>
        <div class="ml-3">
            <p class="mb-0"><b>詳細：</b></p>
            <p class="mb-1">
                - <i>hotel</i>：ホテルのリスト。1件または複数のホテルを定義できます。各ホテルは1つのオブジェクトです（必須）。<br/>
                <span style="padding-left: 12px;"><i>hotelName</i>：ホテル名。</span><br/>
                <span style="padding-left: 12px;"><i>hotelCode</i>：ホテルコード。</span><br/>
            </p>
            <p class="mb-1">
                - <i>target</i>：ステップ1で定義したHTMLタグのID（#）またはクラス（.）（必須）。
            </p>
            <p class="mb-1">
                - <i>path</i>：部屋リストを表示するページへのパス。未設定の場合は <code>https://booking.ezcms.vn</code> にリダイレクトされます（オプション）。
            </p>
            <p class="mb-1">
                - <i>lang</i>：フォームおよび部屋リストの表示言語。未設定の場合はデフォルトでベトナム語になります（オプション）。<br/>
                <span style="padding-left: 12px;"><b>対応言語（7つ）：</b></span><br/>
                <span style="padding-left: 12px;"><i>vi</i>：ベトナム語</span><br/>
                <span style="padding-left: 12px;"><i>en</i>：英語</span><br/>
                <span style="padding-left: 12px;"><i>ja</i>：日本語</span><br/>
                <span style="padding-left: 12px;"><i>ko</i>：韓国語</span><br/>
                <span style="padding-left: 12px;"><i>lo</i>：ラオス語</span><br/>
                <span style="padding-left: 12px;"><i>km</i>：クメール語</span><br/>
                <span style="padding-left: 12px;"><i>zh</i>：中国語</span><br/>
                <span style="padding-left: 12px;"><b>注意：</b> Booking Engine に選択した言語の設定がない場合、デフォルトで英語が表示されます。</span>
            </p>   
            <p class="mb-1">
                - <i>background</i>：フォームの背景色。デフォルト：#eee（オプション）。
            </p>
            <p class="mb-1">
                - <i>buttonTextColor</i>：「部屋を探す」ボタンの文字色。デフォルト：#fff（オプション）。
            </p>
            <p class="mb-1">
                - <i>buttonBackground</i>：「部屋を探す」ボタンの背景色。デフォルト：赤（オプション）。
            </p>
            <p class="mb-1">
                - <i>textColor</i>：フォーム内の文字色。デフォルトはブラウザの標準設定（オプション）。
            </p>  
        </div>
        <p class="mt-3 mb-0">
            <b>ステップ4：</b> ステップ3で設定したパスにあるホテルの部屋リスト表示ページにて
        </p>
        <p class="mb-0">
            以下のHTMLサンプルをコピーし、部屋リストを表示したい位置に貼り付けます。<br/>
            <i>&lt;div id="room-list"&gt;&lt;/div&gt;</i>
        </p>
        <p class="mb-3">
            以下のスクリプトをコピーして、ウェブサイトのフッター（body タグの直前）に貼り付けます。<br/>
            <i> &emsp;&lt;script src="https://app.oneinventory.com/booking-engine/plugins/ezbe-embed.js"&gt;&lt;/script&gt; <br>
                &emsp;&lt;script&gt;<br>
                &emsp;&emsp;window.initBookingEngine({<br>
                &emsp;&emsp;&emsp; target: '#room-list',<br>
                &emsp;&emsp;&emsp; scrollToTop: true,<br>
                &emsp;&emsp;&emsp; marginTop: 0<br>
                &emsp;&emsp;});<br>
                &emsp;&lt;/script&gt;<br>
            </i>
        </p>
        <p class="mb-0">
            <b>ステップ5：</b> 保存前に <b>window.initBookingEngine</b> 関数のパラメータを調整してください。
        </p>
        <div class="ml-3">
            <p class="mb-0"><b>詳細：</b></p>
            <p class="mb-1">
                - <i>target</i>：ステップ4で定義したHTMLタグのID（#）またはクラス（.）（必須）。
            </p>
            <p class="mb-1">
                - <i>scrollToTop</i>：スクロール位置が500pxを超えるとページトップに戻るアイコンを表示。クリックでトップに戻ります。デフォルトはfalse（オプション）。
            </p>
            <p class="mb-1">
                - <i>marginTop</i>：上側に余白を作ります。目的は、固定された上部要素（例：固定ヘッダー）がコンテンツを覆い隠さないようにすることです（任意）。
            </p>
        </div>
        <p style="margin-top: 10px;"><b>デモページを見るには </b><a href="https://app.oneinventory.com/booking-engine" target="_blank">こちら</a></p>`,
    },
    CONFIRM_TRANET_CONNECT: `{roomConfirm} は最大収容人数18名を超えています。マップをクリックすると、<span class="font-weight-bold">マッピング失敗</span>が発生する可能性があります。再度ご確認ください。`,
    _PROMOTION: {
        MEALS: {
            BREAKFAST: "朝食",
            LUNCH: "昼食",
            DINNER: "夕食",
        },
        PROMOTION_TYPE_LIST: {
            EVERY_NIGHT: "毎晩",
            TOTAL_BOOKING: "合計予約金額",
            ORDER_BEFORE: "チェックインのx日前までに注文",
            ORDER_WITHIN: "チェックインのx日前以内に注文",
            FREE_QUANTITY: "x個注文でy個無料",
            FREE_ON_TOTAL_VALUE: "x個注文で合計金額からy個無料",
        },
        DISCOUNT_LIST: {
            DISCOUNT: "割引",
            SURCHARGE: "追加料金",
        },
        TARGET_APPLY_LIST: {
            BY_AGENT_LEVEL: "代理店レベル別",
            BY_AGENT: "代理店別",
        },
        LEVEL_TARGET_APPLY: {
            LEVEL_1: "レベル1",
            LEVEL_2: "レベル2",
            LEVEL_3: "レベル3",
            LEVEL_4: "レベル4",
            LEVEL_5: "レベル5",
        }
    },
    UTM_CODE: "UTMコード",
    ZOOM: "ズーム",
    UPDATE_RESTRICTION_SALEINVENTORY: "販売用の部屋を更新する",
    UPDATE_RESTRICTION_SELLLIMIT: "販売制限を更新する",
    ROOM_TYPE_ON_SABRE_DUPLICATE: "販売チャネルの部屋タイプは重複できません",
    ROOM_PLAN_ON_SABRE_DUPLICATE: "販売チャネルの料金プランは重複できません",
    UPDATE_FAILED: "更新に失敗しました",
    DELETE_FAILED: "削除に失敗しました",
    CREATE_FAILED: "作成に失敗しました",
    UPLOAD_FAILED: "アップロードに失敗しました",
    USER_NOT_RIGHT: "権限がありません",
    USER_NOT_EXIST: "アカウントが存在しません",
    EMAI_IS_EXIST: "このメールアドレスはすでに存在します",
    ACTIVE_SUCCESS: "有効化に成功しました",
    DEACTIVE_SUCCESS: "リンク解除に成功しました",
    TODAY: "今日",
    YESTERDAY: "昨日",
    TOMORROW: "明日",
    LOGIN_FAILED: "ログインに失敗しました",
    ONEPAY_INLAND: "OnePay国内",
    ONEPAY_OVERSEA: "OnePay海外",
    VN_PAY: "VN Pay",
    SUN: "日",
    MON: "月",
    TUE: "火",
    WED: "水",
    THU: "木",
    FRI: "金",
    SAT: "土",
    UNDER_MAX_GUEST: "価格ポリシーで許可された最大人数を超えています",
    SAVE_RESULTS_WHEN_MAKING_CHANGES: "変更を加えた後に結果を保存する",
    $vuetify: {
        badge: 'バッジ',
        close: '閉じる',
        dataIterator: {
            noResultsText: '検索結果が見つかりません。',
            loadingText: '項目をロード中です...'
        },
        dataTable: {
            itemsPerPageText: '1ページあたりの行数：',
            ariaLabel: {
                sortDescending: '降順の並び替え。',
                sortAscending: '昇順の並び替え。',
                sortNone: 'ソートされていません。',
                activateNone: 'ソートを削除するには有効にしてください。',
                activateDescending: '降順の並び替えのためには有効にしてください。',
                activateAscending: '昇順のソートのためには有効にしてください。'
            },
            sortBy: 'ソート方式'
        },
        dataFooter: {
            itemsPerPageText: '1ページあたりの件数：',
            itemsPerPageAll: 'すべて',
            nextPage: '次のページ',
            prevPage: '前のページ',
            firstPage: '最初のページ',
            lastPage: '最後のページ',
            pageText: '{0}-{1} 件目 / {2}件'
        },
        datePicker: {
            itemsSelected: '{0}日付選択',
            nextMonthAriaLabel: '来月',
            nextYearAriaLabel: '来年',
            prevMonthAriaLabel: '前月',
            prevYearAriaLabel: '前年'
        },
        noDataText: 'データはありません。',
        carousel: {
            prev: '前のビジュアル',
            next: '次のビジュアル',
            ariaLabel: {
                delimiter: 'カルーセルのスライド {0}件目 / {1}件'
            }
        },
        calendar: {
            moreEvents: 'さらに{0}'
        },
        input: {
            clear: 'Clear {0}',
            prependAction: '{0} prepended action',
            appendAction: '{0} appended action'
        },
        fileInput: {
            counter: '{0} ファイル',
            counterSize: '{0} ファイル (合計 {1})'
        },
        timePicker: {
            am: 'AM',
            pm: 'PM'
        },
        pagination: {
            ariaLabel: {
                wrapper: 'ページネーションナビゲーション',
                next: '次のページ',
                previous: '前のページ',
                page: '{0}ページ目に移動',
                currentPage: '現在のページ、ページ {0}'
            }
        },
        rating: {
            ariaLabel: {
                icon: '評価 {1} のうち {0}'
            }
        },
        loading: 'Loading...'
    },
    DAYS_OF_WEEK: {
        SUN: "日",
        MON: "月",
        TUE: "火",
        WED: "水",
        THU: "木",
        FRI: "金",
        SAT: "土",
    },
    URL_INVALID: "URLが無効です",
    SELECT_ROOM_TYPE: "部屋タイプを選択",
    OTA_CONNECTION_ERROR: "OTA接続エラー",
    ROOM_RATE_TYPE: "ルームタイプ {room} 料金プラン {rate}",
    NOT_MATCH_GUEST_COUNT: "ezCrs と Traveloka 間の宿泊人数の不一致",
    STAFF_MANAGEMENT: "スタッフ管理",
    FUNCTION_MANAGEMENT: "機能管理",
    SETUP_RATE_TYPE: "チャネルからCMに送信された料金タイプを設定",
    INCLUDE_COMMISSION: "手数料を含む",
    EXCLUDE_COMMISSION: "手数料を除外",
    UNDEFINED_COMMISSION: "未定義",
    EXTRA_DATA_TO_OTA: "チャネルからCMに送信された料金タイプを設定します",
    ROOM_TYPE_SYNCED: "このルームタイプはOTAとマッピングされています。再度ご確認ください。",
    MANDATORY_LANGUAGE_REQUIRED: "ベトナム語と英語は必須です。",
    TOOLTIP_TOGGLE_LANGUAGE: "表示言語を変更する際は、ルームタイプ名やポリシー名などの多言語フィールドも必ず更新してください。",
    TOOLTIP_INCLUDE_COMMISSION: `
        <span class="font-weight-bold fs-13">-設定：手数料を除外</span> – チャネルが代金を回収する予約で、十分なデータがある場合、ezCrs は客室料金を再計算します。<br/>
        <span class="font-weight-bold fs-13">-設定：手数料を含む</span> – ezCrs はチャネルから送信された客室料金をそのまま保持します。<br/>
        <span class="font-weight-bold fs-13">-設定：未定義</span> – チャネルから送信された料金に手数料が含まれているかどうかをシステムで判定できない場合に使用します。
        この場合、<span class="font-weight-bold fs-13">手数料を含む</span> と <span class="font-weight-bold fs-13">手数料を除外</span> の両方の項目は <span class="font-weight-bold fs-13">未定義</span> と表示されます。`,
    TOOLTIP_INCLUDE_COMMISSION_AGODA: `
        <span class="font-weight-bold fs-13">-設定：手数料を含む</span> – 十分なデータがある場合、ezCrs は予約の客室料金を再計算します。<br/>
        <span class="font-weight-bold fs-13">-設定：手数料を除外</span> – ezCrs はチャネルから送信された客室料金をそのまま保持します。<br/>
        <span class="font-weight-bold fs-13">-設定：未定義</span> – チャネルから送信された料金に手数料が含まれているかどうかをシステムで判定できない場合に使用します。この場合、
        <span class="font-weight-bold fs-13">手数料を含む</span> と <span class="font-weight-bold fs-13">手数料を除外</span> の両方の項目は <span class="font-weight-bold fs-13">未定義</span> と表示されます。`,
    INPUT_INVALID: "最大数を超えました",
    GOOGLE_NOTE: "<strong>注意：</strong> Google の最新の規定により、Google ホテルを利用する場合は <strong>税金および手数料</strong> のデータを更新する必要があります。システムの有効性を確保し、エラーを防ぐために、<strong>0 より大きい値の税金または手数料を少なくとも 1 つ</strong> 含める必要があります。",
    INVOICE_REQUEST: "請求書のご依頼",
    COMPANY_NAME_OR_BOOKER: "会社名／ご予約者名",
    HIDE_INFORMATION: "（情報を非表示）",
    SHOW_INFORMATION: "（情報を表示）",
    MODULE_EZ_PROMOTION_NOT_ACTIVE: "プロモーションモジュールは有効ではありません",
    INCLUDE_COMMISSION_RATE: "コミッション込み",
    EXCLUDE_COMMISSION_RATE: "コミッション別",
    COMMISSION_RATE_NOTE: "注: 手数料の包含と除外のデータは参考用です",
    SETUP_RATE_TYPE_NOTE: "注意事項：「チャネルからCMへ送信される料金設定」の構成変更は、当該チャネルに少なくとも1つ（01）の客室タイプが正常に接続されている場合にのみ実行可能です。",
};